import { ColDef, ColGroupDef, FilterChangedEvent, GridApi, GridOptions, GridReadyEvent, Module, RowGroupingDisplayType, RowHeightParams, NewColumnsLoadedEvent, CellValueChangedEvent, ICellRendererParams, ExcelExportParams, ExcelCell, ExcelStyle, CellClassParams, ExcelRow, ClientSideRowModelModule, IDetailCellRendererParams, themeQuartz, RowSelectedEvent, RowSelectionOptions, ValidationModule } from 'ag-grid-community';
import { AllEnterpriseModule, ExcelExportModule, MasterDetailModule, RowGroupingModule } from "ag-grid-enterprise";
import { CurrencyPipe, DecimalPipe } from '@angular/common';
import { Component, HostListener, Input, OnChanges, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subject, BehaviorSubject, map, take, takeUntil, switchMap, of, withLatestFrom, combineLatest, skip } from 'rxjs';
import { gridReady } from '../../../create-request/actions/positions-table-actions';
import { PositionsLotsTableColumnMultipleAccounts } from '../../../shared/types/PositionsLotsTableColumn';
import { PositionDetailsForMultiToAccount } from '../../models/internal-transfer/InternalTransferPositions';
import { selectCostBasis, selectPositionsLotsTableState, selectPositionDetails, selectToAccountsInfo, selectTransferType, selectMultipleToAccountsPositionLotTableData, selectPositionLotDetails, selectIsFromEdit, selectIsOneTimeTotalDist, isRestrictedToAccountEntered } from '../../reducers';
import { InputEditorComponent } from '../../../shared/components/input-editor-renderer/input-cell-editor.component';
import { InternalTransfersActions, TransactionFormActions } from '../../actions';
import { AgGridAngular } from 'ag-grid-angular';
import { TextFloatingFilterComponent } from '../../../shared/components/text-floating-filter/text-floating-filter.component';
import { SetFloatingFilterComponent } from '../../../shared/components/set-floating-filter/set-floating-filter.component';
import { CustomErrorTransactionTableComponent } from '../../../shared/components/custom-error-transaction-table/custom-error-transaction-table.component';
import { agFilterNames } from '../../../shared/types/AgFilterNames';
import { positionConstants } from '../../../shared/utilities/Constants';
import { RowDataById, ToAccountInfoById } from '../../models/internal-transfer/InternalTransfersInfo';
import { TextFieldMultiplePositionComponent } from '../../../shared/components/table-text-position-input-field-multiple-to-account/table-text-position-input-field-multiple-to-account.component';
import { TextFieldMultipleLotComponent } from '../../../shared/components/table-text-lot-input-field-multiple-to-account/table-text-lot-input-field-multiple-to-account.component';
import { LotDetails } from '../../models/internal-transfer/LotDetails';
import { DateTime } from 'luxon';
import { selectSubAccountId } from '../../../account-info-header/reducers';
import { costBasisHeaderTemplate, currPricePerShareHeaderTemplate } from '../positions-table-multiple-review/table-helpers';
import { SpinnerComponent } from '../../../shared/components/spinner/spinner.component';
import { selectViewInContext } from '../../../shared/reducers';
import { ReviewInputPositionObservableService } from '../positions-table-multiple-review/reviewInputPositionObservableService';
import { Actions, ofType } from '@ngrx/effects';

interface StickyHeaderColumn {
  colId: string;
  label: string;
  width: number;
  alignment: 'left' | 'right';
  accountContext?: string;
}

// Keep the sticky header alignment rules in one place so the cloned header stays visually in sync with AG Grid.
const STICKY_HEADER_RIGHT_ALIGNED_COLUMNS = new Set([
  'Current price/share',
  'Cost basis',
  'Total cost basis',
  'Est. mkt val',
]);

@Component({
  standalone: false,
  selector: 'positions-table-multiple-to-account',
  templateUrl: './positions-table-multiple-to-account.component.html',
  styleUrls: ['./positions-table-multiple-to-account.component.scss'],
})

export class PositionsTableMultipleToAccountComponent implements OnInit, OnChanges, OnDestroy {
  @ViewChild('myGrid') grid!: AgGridAngular;
  @Input() showFilterCount: boolean;
  @Input() reviewConfirmationPage: boolean;
  @Input() showTableOptions: boolean;
  @Input() showFloatingFilter: boolean;
  @Input() showSelectPositionError: boolean;
  @Input() displayPositionsWarningPhase2: { displayWarning: boolean, toAccounts: string[], errorMessage: string; } = { displayWarning: false, toAccounts: [], errorMessage: '' };
  @Input() maxLotsWarning: { displayWarning: boolean; } = { displayWarning: false };
  @Input() maxLotsWarningMessage: string[];
  @Input() isInitiateAndReleaseFlowFromTable: boolean = false;
  @Input() isOneTimeTotalDist: boolean = false;
  costBasisMethod: string | undefined;
  excelStyles: ExcelStyle[] = [];
  gridApi: GridApi | undefined | null;
  gridApiTotals: GridApi | undefined | null;
  gridColumnApi: GridApi | undefined | null;
  toAccountInfo: ToAccountInfoById | undefined;
  gridColumnApiTotals: GridApi | undefined | null;
  totalDistSelected: boolean = false;
  columnDefs: ColDef[] = [];
  destroy$: Subject<boolean> = new Subject<boolean>();
  rowData$!: Observable<PositionsLotsTableColumnMultipleAccounts[]>;
  positions: number;
  positionsDetails: PositionDetailsForMultiToAccount[];
  toAccounts$: Observable<any[]>;
  displayTable$ = new BehaviorSubject(false);
  tableMessage: string;
  shares: any;
  createRequestStep$: any;
  emvFormatted: string | null;
  lotDetail: PositionsLotsTableColumnMultipleAccounts[];
  detailRowAutoHeight: true;
  showExpandCollapse = true;
  displayedRows: number = 0;
  expandedRowsCount: number = 0;
  numberOfFilters: number = 0;
  expanded: boolean = false;
  lastPage: number | undefined = -1;
  lastPageSize: number | undefined = -1;
  lastPaginationGridHeight: number | undefined;
  sortingOrder: [];
  subAccountId: string;
  frameworkComponents: any;
  customErrorComponent: string;
  customErrorComponentParams: { noRowsMessageFn: (item: string) => string; } = { noRowsMessageFn: (item: string) => 'string' };
  gridHeight: string = '500px';
  gridOptions: GridOptions;
  lastCostBasis: string | undefined = '';
  gridOptionsTotals: GridOptions;
  quantityMismatch: string = positionConstants.positionMismatchRestriction;
  firsttoAccountColumn = '';
  positionMismatchDisclaimer: string = positionConstants.positionMismatchDisclaimer;
  hasAnyQuantityMismatchPositions: boolean = false;
  isEdit: boolean;
  loadingOverlayComponentParams: { loadingFn: (item: boolean) => boolean, lockModalVersion: boolean, };
  loadingOverlayComponent: string;
  checkBoxColumnWidth: number = positionConstants.tableSelectAllCheckboxColumnWidth;
  accountsInContext = 0;
  private toAccountColumnsSyncInitialized = false;
  private scrollToTopAfterLayoutTimeout: ReturnType<typeof setTimeout> | undefined;
  private scheduledLayoutPassTimeouts: ReturnType<typeof setTimeout>[] = [];
  private scheduledGridWidthSyncTimeout: ReturnType<typeof setTimeout> | undefined;
  private pendingLayoutOptions: { syncColumnWidths: boolean, scrollToTop: boolean } = { syncColumnWidths: false, scrollToTop: false };
  private positionsTableTopScrollAnimationFrame: number | undefined;
  private reviewReturnRecoveryTimeouts: ReturnType<typeof setTimeout>[] = [];
  setToAverageCountedMap: { [key: string]: boolean; } = {};
  isRestrictedAccount: boolean;
  hasDuplicateRestriction: boolean = false;
  hasDuplicateRestrictionMF30DaySpecific: boolean = false;
  duplicateRestrictionDisclaimer: string = positionConstants.duplicateRestrictionDisclaimer;
  duplicateRestrictionDisclaimerMF30DaySpecific: string = positionConstants.duplicateRestrictionDisclaimerMF30DaySpecific;
  stickyHeaderColumns: StickyHeaderColumn[] = [];
  stickyHeaderTotalWidth: number = 0;
  stickyHeaderVisible: boolean = false;
  stickyHeaderTopOffset: number = 0;
  stickyBottomScrollHelperVisible: boolean = false;
  stickyBottomScrollHelperViewportWidth: number = 0;
  detailGridTopContextActive: boolean = false;
  detailGridTopContextSymbol: string = '';
  private stickyHeaderScrollContainer: HTMLElement | null = null;
  private stickyHeaderViewportElement: HTMLElement | null = null;
  private stickyHeaderRowElement: HTMLElement | null = null;
  private stickyBottomScrollViewportElement: HTMLElement | null = null;
  private stickyHeaderHorizontalScrollElement: HTMLElement | null = null;
  private stickyHeaderHorizontalAlignmentElement: HTMLElement | null = null;
  private positionsTableBodyElement: HTMLElement | null = null;
  private masterGridHeaderElement: HTMLElement | null = null;
  private masterGridElement: HTMLElement | null = null;
  private masterGridCenterViewportElement: HTMLElement | null = null;
  private masterGridHeaderViewportElement: HTMLElement | null = null;
  private masterGridHeaderContainerElement: HTMLElement | null = null;
  private masterGridCenterContainerElement: HTMLElement | null = null;
  private masterGridLeafHeaderRowElement: HTMLElement | null = null;
  private totalsHorizontalScrollbarElement: HTMLElement | null = null;
  private totalsHorizontalScrollViewportElement: HTMLElement | null = null;
  private stickyHeaderViewportSyncing: boolean = false;
  private stickyHeaderResizeObserver: ResizeObserver | undefined;
  private stickyHeaderRefreshAnimationFrame: number | undefined;
  private pendingStickyHeaderRefresh: { visibility: boolean, context: boolean } = { visibility: false, context: false };
  private readonly stickyHeaderScrollHandler = () => this.scheduleStickyHeaderRefresh({ visibility: true });
  private readonly stickyHeaderHorizontalScrollHandler = () => {
    this.syncStickyHeaderViewportFromGrid();
    this.scheduleStickyHeaderRefresh({ context: true });
  };


  colNames = {
    SelectAllCheckBox: 'selectAllCheckBox',
    expandCollapse: 'expandCollapse',
    positionSymbol: 'Symbol',
    positionName: 'Name',
    availableShares: 'Available shares',
    currentPricePerShare: 'Current price/share',
    costBasis: 'Cost basis',
    sharesToMove: 'Shares to move',
    totalCostBasis: 'Total cost basis',
    estimatedMarketValue: 'Estimated market value',
    acquiredDate: 'Acquired Date',
    holdingPeriod: 'Holding Period'
  };
  totalsRowdata = [
    {
      SelectAllCheckBox: 'selectAllCheckBox',
      Symbol: '',
      Name: 'Totals',
      RowHeight: positionConstants.tableRowHeight,
      'Available shares': '',
      'Current price/share': '',
      'Cost basis': '',
      "lotDetail": '',
      'setToAverage': '',
      'Quantity': '',
      'cmtSequenceId': '',
      'valMultiplier': '',
      'schwabSecurityId': '',
      'detailRows': [],
      'currentAvailableShares': '',
    }
  ];

  public globalModules: Module[] = [
    ValidationModule,
    AllEnterpriseModule,
    ClientSideRowModelModule
  ];

  public modules: Module[] = [
    ...this.globalModules,
    RowGroupingModule,
    MasterDetailModule,
    ExcelExportModule,
  ];

  public groupDisplayType: RowGroupingDisplayType = 'singleColumn';
  autoGroupColumnDef: ColDef = {
    minWidth: 29
  };
  public domLayout: 'autoHeight';
  public defaultColDef: ColDef = {
    sortable: true,
    filter: true
  };
  defaultColumnDefs: ColDef = {
    filter: agFilterNames.text,
    sortingOrder: ['asc', 'desc'],
    suppressHeaderMenuButton: true,
    suppressHeaderContextMenu: true,
    suppressHeaderFilterButton: true,
    sortable: true,
    resizable: false,
    unSortIcon: true,
    minWidth: 29,
    floatingFilter: true
  };
  icons = {
    sortAscending: '<i class="sch-caret-up "/>',
    sortDescending: '<i class="sch-caret-down"/>',
    filter: '<i class="sch-search" />',
    sortUnSort: '<i class="sch-caret-down"/>',
    groupExpanded: '<i class="sch-chevron-down"/>',
    groupContracted: '<i class="sch-chevron-right"/>'
  };
  showSetToAverageMessageCounter: number = 0;
  setToAverageInformationText: string = positionConstants.SetToAverageInformationMessage;
  selectPositionErrorText: string = positionConstants.SelectPositionErrormessage;
  titleText: string = positionConstants.maxLotsWarningPhase2;
  defColumnDefs: (ColDef | ColGroupDef)[] = [
    {
      field: this.colNames.positionSymbol,
      floatingFilterComponent: 'customTextFloatingFilter',
      minWidth: 185,
      maxWidth: 185,
      lockPosition: true,
      floatingFilterComponentParams: {
        suppressFilterButton: true
      },
      cellRenderer: 'agGroupCellRenderer',
      cellRendererParams: {
        suppressDoubleClickExpand: true,
      },
    },
    {
      field: this.colNames.positionName,
      tooltipField: this.colNames.positionName,
      resizable: false,
      cellStyle: { 'text-overflow': 'ellipsis', 'white-space': 'nowrap', 'overflow': 'hidden' },
      cellClass: params => {
        return params.data['Name'] !== 'Totals' ? 'custom-filter' : 'totalsLabel';
      },
      filterParams: { showTooltips: true },
      lockPosition: true,
      minWidth: 320,
      flex: 1,
      floatingFilterComponent: 'customTextFloatingFilter',
      floatingFilterComponentParams: {
        suppressFilterButton: true
      },
    },
    {
      field: this.colNames.availableShares,
      headerName: this.colNames.availableShares,
      minWidth: 185,
      filter: false,
      lockPosition: true,
      comparator: (valueA, valueB) => {
        const sharesA = parseInt(valueA.substring(0).replace(/,/g, ""));
        const sharesB = parseInt(valueB.substring(0).replace(/,/g, ""));
        return sharesA - sharesB;
      },
      cellClass: params => {
        if (params.data['Name'] === 'Totals') { return 'leftAlignClass'; }
        if (params.value.charAt(0) === '-') { return 'shortPositionText'; }
        return '';
      },
    },
    {
      field: this.colNames.currentPricePerShare,
      headerName: this.colNames.currentPricePerShare,
      resizable: false,
      type: 'rightAligned',
      minWidth: 150,
      lockPosition: true,
      comparator: this.currencyComparator,
      filter: false,
      headerComponentParams: {
        template: currPricePerShareHeaderTemplate
      }
    },
    {
      field: this.colNames.costBasis,
      headerName: this.colNames.costBasis,
      resizable: false,
      type: 'rightAligned',
      minWidth: 180,
      lockPosition: true,
      comparator: this.currencyComparator,
      filter: false,
      cellClass: params => {
        if (params.value.charAt(0) === '-') { return ['rightTextAndBorder', 'shortPositionText']; }
        return 'rightTextAndBorder';
      },
      headerComponentParams: {
        template: costBasisHeaderTemplate
      }
    },
    {
      field: 'LotDetail',
      headerName: '',
      resizable: false,
      width: 0,
      sortable: false,
      filter: false,
      hide: true,

    },
    {
      field: 'currentAvailableShares',
      headerName: '',
      resizable: false,
      width: 0,
      sortable: false,
      filter: false,
      hide: true
    },
  ];

  public detailCellRendererParams: any = {
    refreshStrategy: "nothing",
    detailGridOptions: {
      stopEditingWhenCellsLoseFocus: true,
      singleClickEdit: true,
      rowHeight: positionConstants.tableRowHeight,
      enterNavigatesVerticallyAfterEdit: true,
      headerHeight: 29,
      components: {
        customEditor: InputEditorComponent,
        positionInputEditor: TextFieldMultiplePositionComponent,
        positionInputDisplay: TextFieldMultiplePositionComponent,
        lotInputEditor: TextFieldMultipleLotComponent,
        lotInputDisplay: TextFieldMultipleLotComponent
      },
      onCellValueChanged: function (params: CellValueChangedEvent) {
        const isLotsToMoveUpdated = (params?.colDef?.field?.includes('Lots to move') ?? false)
          && params.newValue !== params.oldValue
          && (!!params.newValue || !!params.oldValue);
        if (isLotsToMoveUpdated) {
          let toAccountKey = params?.colDef?.field?.toString().split(' ')[3];
          params.node.setDataValue('nodeChangedLot ' + toAccountKey, true);
          params.node.data.masterNode.node.setDataValue('nodeChanged ' + toAccountKey, true);
        }
      },
      setColumnVisible(index: number, shouldShowColumn: boolean = true) {
        this.columnDefs[index].hide = !shouldShowColumn;
      },
      sizeColumnsToMatchMasterTable(gridColumnApi: GridApi) {
        this.columnDefs.forEach((lotColumn) => {
          lotColumn.width = gridColumnApi?.getColumn(this.getMasterColumn(lotColumn))?.getActualWidth() ?? lotColumn.width;
        });
      },
      getMasterColumn(lotColumn: any): string {
        if (lotColumn.colId === 'selectAllCheckBox') {
          return this.colNames.SelectAllCheckBox;
        }
        if (lotColumn.colId === 'positonSymbol') {
          return this.colNames.positionSymbol;
        }
        if (lotColumn.field === 'Acquired date') {
          return this.colNames.positionName;
        }
        if (lotColumn.field === 'Holding Period') {
          return this.colNames.availableShares;
        }
        if (lotColumn.field === 'Current price/share') {
          return this.colNames.currentPricePerShare;
        }
        if (lotColumn.field === 'Cost Basis') {
          return this.colNames.costBasis;
        }
        if (lotColumn.field === 'Lots to move' + ' ' + lotColumn.groupId) {
          return this.colNames.sharesToMove + ' ' + lotColumn.groupId;
        }
        if (lotColumn.field === 'TotalCostBasis' + ' ' + lotColumn.groupId) {
          return this.colNames.totalCostBasis + ' ' + lotColumn.groupId;
        }
        if (lotColumn.field === 'Estimated market value' + ' ' + lotColumn.groupId) {
          return this.colNames.estimatedMarketValue + ' ' + lotColumn.groupId;
        }
        return '';
      },
      removeToAccountLotColumns(toAccount: string) {
        this.columnDefs.forEach((column, index) => {
          if ('groupId' in column && column['groupId'] === toAccount) {
            this.columnDefs.splice(index, 3);
          }
        });
      },
      colNames: {
        SelectAllCheckBox: 'selectAllCheckBox',
        expandCollapse: 'expandCollapse',
        positionSymbol: 'Symbol',
        positionName: 'Name',
        availableShares: 'Available shares',
        currentPricePerShare: 'Current price/share',
        costBasis: 'Cost basis',
        sharesToMove: 'Shares to move',
        totalCostBasis: 'Total cost basis',
        estimatedMarketValue: 'Estimated market value',
        acquiredDate: 'Acquired Date',
        holdingPeriod: 'Holding Period'
      },
      columnDefs: [
        {
          suppressHeaderMenuButton: true,
          suppressHeaderContextMenu: true,
          suppressHeaderFilterButton: true,
          field: '',
          headerName: '',
          relatedMasterColumn: this.colNames.SelectAllCheckBox,
          resizable: false,
          headerClass: 'detailSubHeadernoBorder',
          lockPosition: true,
          width: this.checkBoxColumnWidth,
          minWidth: this.checkBoxColumnWidth,
          maxWidth: this.checkBoxColumnWidth,
          sortable: false,
          cellStyle: {
            backgroundColor: '#F1F1F1',
          },
          hide: false,
          colId: 'selectAllCheckBox'
        },
        {
          field: '',
          headerName: '',
          resizable: false,
          minWidth: 100,
          filter: false,
          lockPosition: true,
          headerClass: 'detailSubHeadernoBorder',
          sortable: false,
          headerComponentParams: {
            template:
              `<div data-ref="eLabel" class="ag-header-cell-label" role="presentation">
                  <span data-ref="eText" class="ag-header-cell-text" role="columnheader"></span>
              </div>`
          },
          cellStyle: (params: any) => {
            return { backgroundColor: '#F1F1F1' };
          },
          colId: 'positonSymbol',
        },
        {
          field: 'Acquired date',
          headerName: 'Acquired Date',
          resizable: false,
          minWidth: 100,
          filter: false,
          lockPosition: true,
          headerClass: 'detailSubHeadernoBorder',
          sort: 'desc',
          sortable: true,
          sortingOrder: ['asc', 'desc'],
          icons: {
            sortAscending: '<i class="sch-caret-up"/>',
            sortDescending: '<i class="sch-caret-down"/>',
          },
          headerComponentParams: {
            template:
              `<div data-ref="eLabel" class="ag-header-cell-label" style="position:absolute; padding-top: 6px;">
              <span data-ref="eText" class="subGridheader"></span>
              <span data-ref="eSortAsc"></span>
              <span data-ref="eSortDesc"></span>
            </div>`
          },
          comparator: (valueA: string, valueB: string) => (new Date(valueA) > new Date(valueB)) ? 1 : -1,
          cellClass: 'subGridCell',
        },
        {
          field: 'Holding Period',
          headerName: '',
          resizable: false,
          minWidth: 100,
          filter: false,
          lockPosition: true,
          sortable: false,
          headerClass: 'detailSubHeadernoBorder',
          headerComponentParams: {
            template:
              `<div data-ref="eLabel" class="ag-header-cell-label" role="presentation">
                  <span data-ref="eText" class="ag-header-cell-text" role="columnheader"></span>
              </div>`
          },
          cellClass: (params: CellClassParams) => {
            if (params.value.charAt(0) === '-') { return ['subGridCell', 'shortPositionText']; }
            return 'subGridCell';
          },
        },
        {
          field: 'Current price/share',
          headerName: '',
          resizable: false,
          minWidth: 100,
          filter: false,
          lockPosition: true,
          sortable: false,
          headerClass: 'detailSubHeadernoBorder',
          headerComponentParams: {
            template:
              `<div data-ref="eLabel" class="ag-header-cell-label" role="presentation">
                  <span data-ref="eText" class="ag-header-cell-text" role="columnheader"></span>
              </div>`
          },
          type: 'rightAligned',
          cellClass: 'subGridCellV2',
        },
        {
          field: 'Cost Basis',
          headerName: '',
          resizable: false,
          minWidth: 100,
          filter: false,
          lockPosition: true,
          headerClass: 'detailSubHeader',
          sortable: false,
          headerComponentParams: {
            template:
              `<div data-ref="eLabel" class="ag-header-cell-label" role="presentation">
                  <span data-ref="eText" class="ag-header-cell-text" role="columnheader"></span>
              </div>`
          },
          type: 'rightAligned',
          cellClass: (params: CellClassParams) => {
            if (params.value.charAt(0) === '-') { return ['subGridCellV2', 'rightTextAndBorder', 'shortPositionText']; }
            return ['subGridCellV2', 'rightTextAndBorder'];
          },
        },
        {
          field: 'currentAvailableShares',
          headerName: '',
          resizable: false,
          width: 0,
          filter: false,
          sortable: false,
          hide: true
        }
      ],
    },
    getDetailRowData: (params: any) => {
      const lotsResponse: any[] = Array.of(params.data.lotDetail);
      let rowDataById: RowDataById = {};
      let i = 0;
      let toAccountKeys: string[] = [];
      let fullLotDetails: Array<any> = [];
      let lotDetail: Array<any> = [];
      // Read the store snapshot once before building the detail rows so opening a detail grid does not resubscribe for every lot.
      this.store.select(selectMultipleToAccountsPositionLotTableData).pipe(take(1)).subscribe(rowData => {
        rowDataById = rowData ?? {};
        toAccountKeys = Object.keys(rowDataById);
      });
      while (lotsResponse[0].length > i) {
        lotDetail = lotsResponse.map(position => {
          let detail: Record<string, any> = {
            'Acquired date': position[i].acquiredDate,
            'Holding Period': this.decimalPipe.transform(position[i].lotQuantity, '1.0-6') + ' (' + position[i].holdingPeriod.toLowerCase() + '-term' + ')',
            'Symbol': params.data['Symbol'],
            'Current price/share': params.data['Current price/share'],
            'Cost Basis': this.currencyPipe.transform(position[i].costBasis),
            'setToAverage': position.setToAverage,
            'restrictions': params.data.restrictions,
            'valMultiplier': params.data.valMultiplier,
            'masterNode': params,
            'lotId': position[i]['lotId'],
            'currentAvailableShares': Number(position[i].lotQuantity),
          };
          Object.entries(rowDataById).forEach(([key, entry]) => {
            const storePosition = entry?.positionData?.find(data => data.schwabSecurityId === params.data['schwabSecurityId']);
            const storeLot = storePosition?.lotDetail?.find((lot: { [x: string]: any; }) => lot['lotId'] === detail['lotId']);
            if (!!storeLot && !!storeLot['lotsToMove']) {
              detail[`Lots to move ${key}`] = storeLot['lotsToMove'];
              detail[`Estimated market value ${key}`] = storeLot['estimatedMarketValue'];
              detail[`TotalCostBasis ${key}`] = storeLot['totalCostBasis'];
              detail[`lotHasError ${key}`] = storeLot['lotHasError'];
            }
          });
          let lotsToMoveNotEmpty = this.checkEmptyLots(detail, toAccountKeys);
          if (!this.reviewConfirmationPage || lotsToMoveNotEmpty || this.costBasisMethod !== 'None' || this.isEdit) {
            return detail;
          }
        });
        i++;
        fullLotDetails = fullLotDetails.concat(lotDetail);
      }
      if (!this.reviewConfirmationPage || this.isEdit) {
        params.successCallback(fullLotDetails);
      } else {
        fullLotDetails = fullLotDetails.filter(Boolean);
        params.successCallback(fullLotDetails);
      }
    }
  };

  checkEmptyLots(detailRow: any, toAccountKeys: string[]) {
    let movingLots = false;
    toAccountKeys.forEach((key: string) => {
      if (detailRow['Lots to move ' + key] !== undefined && detailRow['Lots to move ' + key] !== "") {
        movingLots = true;
      }
    });
    return movingLots;
  }

  setHasAnyQuantityMismatchPositions(): void {
    this.recomputeRestrictionFlags();
  }

  setHasAnyDuplicateRestrictionPositions(): void {
    this.recomputeRestrictionFlags();
  }

  setHasAnyMF30DaySpecificDuplicateRestrictionPositions(): void {
    this.recomputeRestrictionFlags();
  }

  // Recompute all restriction flags in one pass so the grid and banners stay consistent without repeating the same scan.
  private recomputeRestrictionFlags(): void {
    this.hasAnyQuantityMismatchPositions = false;
    this.hasDuplicateRestriction = false;
    this.hasDuplicateRestrictionMF30DaySpecific = false;

    this.gridApi?.forEachNode((row) => {
      const restrictionsInfo = row.data?.restrictionsInfo;

      if (!restrictionsInfo) {
        return;
      }

      for (const key in restrictionsInfo) {
        const restrictionText = restrictionsInfo[key]?.restriction?.restrictionText;

        if (restrictionText === positionConstants.positionMismatchRestriction) {
          this.hasAnyQuantityMismatchPositions = true;
        }

        if (restrictionText?.startsWith('DUPLICATE')) {
          if (this.isMF30DaySpecificDuplicateRestrictionText(restrictionText)) {
            this.hasDuplicateRestrictionMF30DaySpecific = true;
          } else {
            this.hasDuplicateRestriction = true;
          }
        }
      }
    });
  }

  getHeaderName(toAccountInfo: ToAccountInfoById, key: string): string {
    if (toAccountInfo[key].accountRegistration[0]) {
      return this.convertToCamelCase(toAccountInfo[key].accountRegistration[0]) + ' - ' + key;
    } else {
      return toAccountInfo[key].regTypeShortName + ' - ' + key;
    }
  }

  isRowRestricted(params: any, toAccount: string) {
    if (params.data['Name'] == 'Totals') {
      return false;
    }
    if (params.data.restrictionsInfo[toAccount]?.restriction.isRestricted) {
      if ((params.data.restrictionsInfo[toAccount].restriction.restrictionText === this.quantityMismatch && this.costBasisMethod !== "None") || (params.data.restrictionsInfo[toAccount].restriction.restrictionText.startsWith('DUPLICATE') && this.costBasisMethod !== "None")) {
        return false;
      }
      else {
        return true;
      }
    }
    return false;
  }

  onRowDataUpdated() {
    this.removeSpinner();
    this.store.select(selectToAccountsInfo).pipe(take(1)).subscribe(toAccountInfo => {
      this.setTotalCostBasisNA(toAccountInfo);
      this.recomputeRestrictionFlags();
    });
  }

  AddToAccountColumns(ToAccountInfo: ToAccountInfoById) {
    for (const key in ToAccountInfo) {
      if (!this.defColumnDefs.find(col => 'groupId' in col && col.groupId === key) && key !== '') {
        this.defColumnDefs.push({
          headerName: this.getHeaderName(ToAccountInfo, key),
          headerTooltip: this.getHeaderName(ToAccountInfo, key),
          //headerClass: 'groupHeaderPaddingAndBorder',
          groupId: key,
          children: [
            {
              field: this.colNames.sharesToMove + ' ' + key,
              wrapText: true,
              headerName: this.colNames.sharesToMove,
              resizable: false,
              minWidth: 130,
              maxWidth: 135,
              headerComponentParams: {
                template:
                  `<div data-ref="eLabel" class="ag-header-cell-label" role="presentation">
                  <span data-ref="eText" class="ag-header-cell-text" role="columnheader"></span>
                  <span data-ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>
                  <span data-ref="eSortAsc"></span>
                  <span data-ref="eSortDesc"></span>
                  <span data-ref="eSortNone"></span>
                </div>`
              },
              colSpan: params => this.isRowRestricted(params, key) ? 3 : 1,
              lockPosition: true,
              comparator: this.currencyComparator,
              filter: false,
              cellClass: params => {
                return params.data['Name'] !== 'Totals' ? 'restrictionsClass' : 'rightBorder';
              },
              editable: params => this.costBasisMethod !== "None" && !this.isRowRestricted(params, key) && !this.totalDistSelected && params.data['Name'] !== 'Totals',
              cellEditor: 'positionInputEditor',
              cellEditorParams: {
                mode: 'edit',
                toAccount: key,
              },
              cellRendererParams: {
                mode: 'render',
                toAccount: key,
              },
              onCellValueChanged: (params) => {
                this.setRowSelected(params.node, key);
              },
              cellRendererSelector: (params) => {
                if (this.totalDistSelected && !this.isRowRestricted(params, key)) {
                  return {
                    component: (params: ICellRendererParams) => "<span class='readOnlyText' >" + params.value + "</span>"
                  };
                }
                if (this.isRowRestricted(params, key)) {
                  const restrictionText = params?.data?.restrictionsInfo?.[key]?.restriction?.restrictionText ?? '';
                  const isDuplicateRestriction = this.isDuplicateRestrictionText(restrictionText);
                  const iconMarkup = isDuplicateRestriction ? "<i class='sch-exclamation-triangle duplicateRestrictionIcon'></i>" : "";
                  const textClass = isDuplicateRestriction ? 'restrictionText duplicateRestrictionText' : 'restrictionText';
                  return {
                    component: (params: ICellRendererParams) => "<span class='" + textClass + "'>" + iconMarkup + this.changeErrorMessage(restrictionText) + "</span>",
                  };
                }
                if (params.data['Name'] !== 'Totals') {
                  if ((params.value === '' || !!params.value)) {
                    return {
                      component: 'positionInputDisplay',
                    };
                  } else if (this.costBasisMethod === 'None') {
                    return { component: (params: ICellRendererParams) => "" };
                  } else {
                    return {
                      component: (params: ICellRendererParams) => `<input class='sdps-input sdps-input--small' value="${params.value ?? ''}">`
                    };
                  }
                } else {
                  return {
                    component: (params: ICellRendererParams) => "<span class='totalsSharesToMoveAlignClass'>" + params.value + "</span>"
                  };
                }
              },
            },
            {
              field: this.colNames.totalCostBasis + ' ' + key,
              headerName: this.colNames.totalCostBasis,
              resizable: false,
              minWidth: 190,
              maxWidth: 200,
              headerComponentParams: {
                template:
                  `<div data-ref="eLabel" class="ag-header-cell-label" role="presentation">
                  <span data-ref="eText" class="ag-header-cell-text" role="columnheader"></span>
                </div>`
              },
              sortable: false,
              type: 'rightAligned',
              filter: false,
              lockPosition: true,
              cellClass: params => {
                if (params.data['Name'] === 'Totals') { return 'costBasisTotals'; }
                if (params?.value?.charAt(0) === '-') { return 'shortPositionText dashedRightBorder'; }
                return 'dashedRightBorder';
              },
            },
            {
              field: this.colNames.estimatedMarketValue + ' ' + key,
              headerName: 'Est. mkt val',
              resizable: false,
              minWidth: 185,
              maxWidth: 200,
              headerComponentParams: {
                template:
                  `<div data-ref="eLabel" class="ag-header-cell-label" role="presentation">
                  <span data-ref="eText" class="ag-header-cell-text" role="columnheader"></span>
                </div>`
              },
              comparator: this.currencyComparator,
              sortable: false,
              type: 'rightAligned',
              filter: false,
              lockPosition: true,
              cellClass: params => {
                if (params.data['Name'] === 'Totals') { return 'rightTextAndBorderEmv totalsText'; }
                if (params?.value?.charAt(0) === '-') { return 'shortPositionText rightTextAndBorderEmv'; }
                return 'rightTextAndBorderEmv';
              },
            },
            {
              field: 'hasError' + ' ' + key,
              headerName: '',
              resizable: false,
              width: 0,
              sortable: false,
              filter: false,
              hide: true,
            },
            {
              field: 'multipleLineErrorCount' + ' ' + key,
              headerName: '',
              resizable: false,
              width: 0,
              sortable: false,
              filter: false,
              hide: true
            },
            {
              field: 'nodeChanged' + ' ' + key,
              headerName: '',
              resizable: false,
              width: 0,
              sortable: false,
              filter: false,
              hide: true
            },
            {
              field: 'lastToAccountUpdated',
              headerName: '',
              resizable: false,
              width: 0,
              sortable: false,
              filter: false,
              hide: true
            }
          ]
        });
        this.detailCellRendererParams.detailGridOptions.columnDefs.push(
          {
            field: 'Lots to move' + ' ' + key,
            groupId: key,
            headerName: '',
            headerClass: 'detailSubHeadernoBorder',
            resizable: false,
            type: 'rightAligned',
            width: 50,
            filter: false,
            cellClass: ['restrictionsClass', 'subGridCell'],
            sortable: false,
            lockPosition: true,
            cellEditor: 'lotInputEditor',
            cellEditorParams: {
              mode: 'edit',
              toAccount: key,
            },
            cellRendererParams: {
              mode: 'render',
              toAccount: key,
            },
            headerComponentParams: {
              template:
                `<div data-ref="eLabel" class="ag-header-cell-label" role="presentation">
                <span data-ref="eText" class="ag-header-cell-text" role="columnheader"></span>
              </div>`
            },
            editable: (params: any) => this.costBasisMethod === "None" && !this.isRowRestricted(params.data.masterNode, key),
            cellRendererSelector: (params: any) => {
              if (this.costBasisMethod !== "None" || this.isRowRestricted(params.data.masterNode, key)) {
                return { component: (params: ICellRendererParams) => "" };
              }
              if (params.value === '' || !!params.value) {
                return { component: 'lotInputDisplay' };
              }
              return {
                component: (params: ICellRendererParams) => `<input class='sdps-input sdps-input--small' value="${params.value ?? ''}">`
              };
            }
          },
          {
            field: 'TotalCostBasis' + ' ' + key,
            groupId: key,
            headerName: '',
            headerClass: 'detailSubHeadernoBorder',
            resizable: false,
            type: 'rightAligned',
            width: 50,
            filter: false,
            cellClass: (params: CellClassParams) => {
              return (params?.value?.charAt(0) === '-') ? ['shortPositionText', 'dashedRightBorder', 'subGridCell'] : ['dashedRightBorder', 'subGridCell'];
            },
            headerComponentParams: {
              template:
                `<div data-ref="eLabel" class="ag-header-cell-label" role="presentation">
                <span data-ref="eText" class="ag-header-cell-text" role="columnheader"></span>
              </div>`
            },
            sortable: false,
            lockPosition: true,
          },
          {
            field: 'Estimated market value' + ' ' + key,
            groupId: key,
            headerName: '',
            headerClass: 'detailSubHeadernoBorder',
            resizable: false,
            type: 'rightAligned',
            width: 50,
            filter: false,
            lockPosition: true,
            cellClass: (params: CellClassParams) => {
              return (params?.value?.charAt(0) === '-') ? ['shortPositionText', 'subGridCellV2', 'emvPaddingClass', 'rightTextAndBorder'] : ['subGridCellV2', 'emvPaddingClass', 'rightTextAndBorder'];
            },
            headerComponentParams: {
              template:
                `<div data-ref="eLabel" class="ag-header-cell-label" role="presentation">
                <span data-ref="eText" class="ag-header-cell-text" role="columnheader"></span>
              </div>`
            }
          },
          {
            field: 'lotHasError' + ' ' + key,
            headerName: '',
            resizable: false,
            width: 0,
            sortable: false,
            filter: false,
            hide: true,
          },
          {
            field: 'lotMultipleLineErrorCount' + ' ' + key,
            headerName: '',
            resizable: false,
            width: 0,
            sortable: false,
            filter: false,
            hide: true
          },
          {
            field: 'nodeChangedLot' + ' ' + key,
            headerName: '',
            resizable: false,
            width: 0,
            sortable: false,
            filter: false,
            hide: true
          },
        );
      }
    }
  }

  RemoveToAccountColumns(ToAccountInfo: ToAccountInfoById) { //Need to update to remove lotlevel ToAccount fields
    this.firsttoAccountColumn = '';
    var ToAccountColumns = (this.defColumnDefs.filter(column => 'groupId' in column && 'children' in column && column.groupId) as ColGroupDef[]).map(col => col.groupId);
    var ToAccountColumnsNeedRemove = ToAccountColumns.filter((toAccount): toAccount is string => !!toAccount && !(Object.keys(ToAccountInfo).includes(toAccount)));
    if (!ToAccountColumnsNeedRemove.length) {
      return;
    }

    ToAccountColumnsNeedRemove.forEach(columnGroupId => this.resetAvailbleSharesAfterRemoving(columnGroupId));
    this.defColumnDefs = this.defColumnDefs.filter(column => !('groupId' in column && 'children' in column && !!column.groupId && ToAccountColumnsNeedRemove.includes(column.groupId)));
    this.detailCellRendererParams.detailGridOptions.columnDefs = this.detailCellRendererParams.detailGridOptions.columnDefs.filter((column: ColDef) => {
      const groupId = ('groupId' in column && typeof column.groupId === 'string') ? column.groupId : undefined;
      return !(!!groupId && ToAccountColumnsNeedRemove.includes(groupId));
    });

    setTimeout(() => {
      if (this.costBasisMethod == 'None') {
        this.expandOrCollapseRows(true);
      }
    }, 10);
  }

  isEmptyOrNull(param: any) {
    if (param == undefined || param == null || param == '') {
      return true;
    }
    return false;
  }

  resetAvailbleSharesAfterRemoving(field: string) {
    this.gridApi?.forEachNode(rowNode => {
      var shares = this.isEmptyOrNull(rowNode.data['Shares to move ' + field]) ? 0 : Number(rowNode.data['Shares to move ' + field]);
      var currentShares = rowNode.data['currentAvailableShares'];
      var currentShares = currentShares + shares;
      rowNode.setDataValue('currentAvailableShares', currentShares);
      rowNode.setDataValue('Shares to move ' + field, '');
      rowNode.setDataValue('Estimated market value ' + field, '');
    });
  }

  public mapPositionLotDetails(positionsLotDetails: PositionDetailsForMultiToAccount[]): any[] {
    let response = positionsLotDetails.map(position => {
      var positionColumn: Record<string, any> = {
        Symbol: position.symbol,
        Name: position.setToAverage ? `${this.convertToCamelCase(position.symbolName)} (Set to Average)` : this.convertToCamelCase(position.symbolName),
        RowHeight: positionConstants.tableRowHeight,
        'Available shares': `${this.decimalPipe.transform(position.totalQuantity, '1.0-5')} (${position.numberOfLots} ${position.numberOfLots === 1 ? 'lot' : 'lots'})`,
        'Current price/share': position.currentPricePerShare,
        'Cost basis': position.costBasis,
        "lotDetail": position.lots,
        'setToAverage': position.setToAverage,
        'Quantity': position.quantity,
        'cmtSequenceId': position.cmtSequenceId,
        'valMultiplier': position.valMultiplier,
        'schwabSecurityId': position.schwabSecurityId,
        'detailRows': [],
        'currentAvailableShares': Number(position.totalQuantity),
        'restrictionsInfo': position.toAccountPositionDetails
      };
      this.store.select(selectMultipleToAccountsPositionLotTableData).pipe(take(1)).subscribe(rowData => {
        Object.entries(rowData).forEach(([key, entry]) => {
          const storePosition = entry?.positionData?.find(data => data.schwabSecurityId === positionColumn['schwabSecurityId']);
          if (
            this.isEdit &&
            !this.isOneTimeTotalDist &&
            !!storePosition &&
            !!storePosition['Shares to move'] &&
            storePosition['Shares to move'] !== '' &&
            storePosition['setToAverage']
          ) {
            if (!this.setToAverageCountedMap[key]) {
              this.showSetToAverageMessageCounter++;
              this.setToAverageCountedMap[key] = true;
            }
          }
          if (!!storePosition && !!storePosition['Shares to move']) {
            positionColumn[`Shares to move ${key}`] = storePosition['Shares to move'];
            positionColumn[`Estimated market value ${key}`] = storePosition['Estimated market value'];
            positionColumn[`Total cost basis ${key}`] = storePosition['Total cost basis'];
            positionColumn[`hasError ${key}`] = storePosition['hasError'];
          }
          if (this.totalDistSelected && (!position.toAccountPositionDetails[key]?.restriction?.isRestricted || (position.toAccountPositionDetails[key]?.restriction?.isRestricted && (position.toAccountPositionDetails[key]?.restriction?.restrictionText === this.quantityMismatch || position.toAccountPositionDetails[key]?.restriction?.restrictionText.startsWith('DUPLICATE'))))) {
            // Adding 1.0-5 to ensure values with decimals only go up to 5 places. 
            let shares = this.decimalPipe.transform(position.totalQuantity, '1.0-5');
            positionColumn[`Total cost basis ${key}`] = 'N/A';
            positionColumn[`Shares to move ${key}`] = shares?.replaceAll(',', '')?.replace('-', '');
            positionColumn[`Estimated market value ${key}`] = this.currencyPipe.transform(Number(position.totalQuantity) * Number(position.currentPricePerShare?.toString()?.replace('$', '')?.replaceAll(',', '')) * Number(position.valMultiplier));
          } else if (this.totalDistSelected && position.toAccountPositionDetails[key]?.restriction?.isRestricted && position.toAccountPositionDetails[key]?.restriction?.restrictionText !== this.quantityMismatch && !position.toAccountPositionDetails[key]?.restriction?.restrictionText.startsWith('DUPLICATE')) {
            positionColumn[`Shares to move ${key}`] = '';
            positionColumn[`Estimated market value ${key}`] = '';
            positionColumn[`Total cost basis ${key}`] = '';
          }
        });
      });
      let posString = JSON.stringify(positionColumn);
      let notEmpty = posString.includes('Shares to move');
      if (!this.reviewConfirmationPage || notEmpty || this.isEdit) {
        return positionColumn;
      }
    });
    if (!this.reviewConfirmationPage || this.isEdit) {
      return response;
    } else {
      return response.filter(Boolean);
    }
  };


  ngOnInit(): void {
    this.frameworkComponents = {
      customTextFloatingFilter: TextFloatingFilterComponent,
      customSetFloatingFilter: SetFloatingFilterComponent,
      customErrorComponent: CustomErrorTransactionTableComponent,
      customEditor: InputEditorComponent,
      positionInputEditor: TextFieldMultiplePositionComponent,
      positionInputDisplay: TextFieldMultiplePositionComponent,
      spinner: SpinnerComponent
    };
    this.createRequestStep$ = this.store.select(selectViewInContext);
    this.customErrorComponent = 'customErrorComponent';
    this.loadingOverlayComponent = 'spinner';
    this.displayedRows = this.gridApi?.getDisplayedRowCount() ?? 0;
    this.numberOfFilters = this.setNumberOfFilters();
    this.columnDefs = this.defColumnDefs;

    this.loadingOverlayComponentParams = {
      loadingFn: () => { return false; },
      lockModalVersion: false
    };

    // skip(3) so that we allow the store to initialize with rowData from initializeRowDataStore 
    // in managePositionLotTableState() method first before overwriting it with updateStoreAllPositions()
    this.store.select(selectCostBasis).pipe(skip(3), takeUntil(this.destroy$)).subscribe(info => {
      this.costBasisMethod = info;
      this.updateStoreAllPositions();
    });
    this.store.select(selectCostBasis).pipe(take(3), takeUntil(this.destroy$)).subscribe(info => {
      this.costBasisMethod = info;
    });
    this.store.select(selectToAccountsInfo).pipe(takeUntil(this.destroy$)).subscribe(info => {
      this.toAccountInfo = info;
    });

    this.store.select(selectIsOneTimeTotalDist).pipe(takeUntil(this.destroy$)).subscribe(isTotalDist => {
      this.totalDistSelected = isTotalDist;
    });

    this.store.select(selectIsFromEdit).pipe(takeUntil(this.destroy$)).subscribe(isfromEdit => this.isEdit = isfromEdit);

    this.store.select(selectPositionDetails).pipe(takeUntil(this.destroy$)).subscribe(info => {
      this.positions = info.totals.totalNoOfPositions;
      this.positionsDetails = info.positions;
      this.shares = this.decimalPipe.transform(info.totals.totalQuantity, '1.0-6');
      this.emvFormatted = this.currencyPipe.transform(info.totals.totalEstimatedMarketValue);
    });
    this.rowData$ = this.store.select(selectPositionDetails).pipe(
      (takeUntil(this.destroy$)),
      map(positionsLotDetails => this.mapPositionLotDetails(positionsLotDetails.positions))
    );

    this.actions$.pipe(ofType(TransactionFormActions.continueClickTotalDist)).pipe(takeUntil(this.destroy$), withLatestFrom(this.store.select(selectToAccountsInfo))).subscribe(([continueClickedTotalDist, toAccountInfo]) => {
      this.calculateTotals(toAccountInfo, true);
    });

    this.AddRemoveToAccountColumns();
    this.managePositionLotTableState();
    this.gridOptions = {
      columnDefs: this.columnDefs,
      defaultColDef: this.defaultColumnDefs,
      autoGroupColumnDef: this.autoGroupColumnDef,
      rowClassRules: {
        duplicateRestrictionRow: (params) => this.costBasisMethod === 'None' && this.hasDuplicateRestrictionInRow(params?.data),
        duplicateNoExpandRow: (params) => this.hasDuplicateRestrictionInRow(params?.data)
      },
      isRowMaster: () => true,
      embedFullWidthRows: true,
      stopEditingWhenCellsLoseFocus: true,
      singleClickEdit: true,
      enterNavigatesVerticallyAfterEdit: true,
      theme: 'legacy',
      onRowGroupOpened: (params) => {
        if (params.node.expanded && this.hasDuplicateRestrictionInRow(params?.data)) {
          params.node.setExpanded(false);
          return;
        }
        if (params.node.expanded) {
          this.expandedRowsCount++;
        }
        if (this.expandedRowsCount === this.displayedRows) {
          setTimeout(() => {
            this.gridApi?.redrawRows();
          }, 1000);
          this.expandedRowsCount = 0;
        }
      },
      rowSelection: {
        mode: 'multiRow',
        checkboxes: true,
        headerCheckbox: true,
        hideDisabledCheckboxes: true,
        isRowSelectable: this.isRowsCheckBoxSelectable.bind(this)
      },
      selectionColumnDef: {
        width: this.checkBoxColumnWidth,
        maxWidth: this.checkBoxColumnWidth,
        minWidth: this.checkBoxColumnWidth,
      }
    };
    this.gridOptionsTotals = {
      theme: 'legacy',
      rowSelection: {
        mode: 'multiRow',
        checkboxes: true,
        headerCheckbox: false,
        hideDisabledCheckboxes: true,
        isRowSelectable: () => false,
      },
      selectionColumnDef: {
        width: this.checkBoxColumnWidth,
        maxWidth: this.checkBoxColumnWidth,
        minWidth: this.checkBoxColumnWidth,
      },
    };
  }

  public onGridReady(params: GridReadyEvent) {
    if (this.isEdit) {
      this.store.select(selectCostBasis).pipe(take(1)).subscribe(costBasis => this.lastCostBasis = costBasis);
    }
    this.gridApi = params.api;
    this.gridColumnApi = params.api;
    this.updateValues();
    this.store.select(selectTransferType).pipe(takeUntil(this.destroy$)).subscribe(type => {
      this.applyToAccountColumns(this.toAccountInfo ?? {});
      this.expanded = false;
    });
    this.onCostbasisChanged();
    this.recomputeRestrictionFlags();
    this.rowData$.pipe(takeUntil(this.destroy$)).subscribe(event => {
      setTimeout(() => {
        this.onRowDataUpdated();
        if (this.costBasisMethod === 'None' || this.expanded) {
          this.expandOrCollapseRows(true);
        }
        this.stabilizeGridLayout({ syncColumnWidths: true });

        // Dispatch editLoadComplete after grid is fully ready in edit mode
        if (this.isEdit) {
          this.store.dispatch(TransactionFormActions.editLoadComplete());
        }
      }, 10);
    });

    this.reviewInputPositionObserbableService.$data.pipe(takeUntil(this.destroy$)).subscribe(data => {
      this.handleReviewReturnScroll();
    });

    // Bind the sticky header listeners once the grid exists so later layout passes only resync measurements.
    this.bindStickyHeaderScroll();
    this.bindStickyHeaderResizeObserver();
    this.scheduleGridWidthSync();
  }

  onFirstDataRendered(event: any) {
    this.gridColumnApi?.applyColumnState({
      state: [{
        colId: this.colNames.positionSymbol,
        sort: 'asc'
      }],
    });
    setTimeout(() => {
      this.fitColumnsToAvailableWidth();
      this.gridApi?.redrawRows();
      this.lastPaginationGridHeight = this.getPositionsTableHeight();
    }, 10);
  }

  @HostListener('window:resize')
  onWindowResize() {
    this.updateStickyHeaderTopOffset();
    this.scheduleGridWidthSync();
  }

  onGridSizeChanged() {
    this.scheduleGridWidthSync();
  }

  trackStickyHeaderColumn(index: number, column: StickyHeaderColumn) {
    return column.colId;
  }

  onStickyHeaderViewportScroll(event: Event) {
    if (this.stickyHeaderViewportSyncing || (!this.stickyHeaderHorizontalScrollElement && !this.stickyHeaderHorizontalAlignmentElement)) {
      return;
    }

    const viewport = event.target as HTMLElement | null;
    const scrollLeft = viewport?.scrollLeft ?? 0;

    this.stickyHeaderViewportSyncing = true;
    if (this.stickyHeaderHorizontalScrollElement) {
      this.stickyHeaderHorizontalScrollElement.scrollLeft = scrollLeft;
    }
    if (this.stickyHeaderHorizontalAlignmentElement && this.stickyHeaderHorizontalAlignmentElement !== this.stickyHeaderHorizontalScrollElement) {
      this.stickyHeaderHorizontalAlignmentElement.scrollLeft = scrollLeft;
    }
    this.stickyHeaderViewportSyncing = false;
    this.scheduleStickyHeaderRefresh({ context: true });
  }

  onStickyBottomScrollHelperViewportScroll(event: Event) {
    if (this.stickyHeaderViewportSyncing || (!this.stickyHeaderHorizontalScrollElement && !this.stickyHeaderHorizontalAlignmentElement)) {
      return;
    }

    const viewport = event.target as HTMLElement | null;
    const scrollLeft = viewport?.scrollLeft ?? 0;

    this.stickyHeaderViewportSyncing = true;
    if (this.stickyHeaderHorizontalScrollElement) {
      this.stickyHeaderHorizontalScrollElement.scrollLeft = scrollLeft;
    }
    if (this.stickyHeaderHorizontalAlignmentElement && this.stickyHeaderHorizontalAlignmentElement !== this.stickyHeaderHorizontalScrollElement) {
      this.stickyHeaderHorizontalAlignmentElement.scrollLeft = scrollLeft;
    }
    if (this.stickyHeaderViewportElement) {
      this.stickyHeaderViewportElement.scrollLeft = scrollLeft;
    }
    this.stickyHeaderViewportSyncing = false;
    this.scheduleStickyHeaderRefresh({ context: true });
  }

  isRowsCheckBoxSelectable(node: any): boolean {
    var receivingAccountsRestriction = Object.values(node.data.restrictionsInfo) as any;
    if (receivingAccountsRestriction.length === 1) {
      let restriction = receivingAccountsRestriction[0].restriction;
      if (!restriction.isRestricted ||
        (restriction.isRestricted &&
          (restriction.restrictionText === this.quantityMismatch || restriction.restrictionText.startsWith('DUPLICATE'))
          && this.costBasisMethod !== "None")
      ) {
        return true;
      }
    }
    return false;
  }

  setRowSelected(node: any, toAccount: string) {
    if (node.data['Available shares']?.split(' ')[0].replaceAll(',', '') === node.data['Shares to move ' + toAccount] && !node.isSelected()) {
      node.setSelected(true);
    }
    if (node.data['Available shares']?.split(' ')[0].replaceAll(',', '') !== node.data['Shares to move ' + toAccount] && node.isSelected()) {
      node.setSelected(false);
    }
  }


  async onRowSelected(event: any) {
    if (event.source === 'checkboxSelected' || event.source === 'uiSelectAll') {
      this.gridApi?.setGridOption('loading', true);
      this.store.select(selectToAccountsInfo).pipe(take(1)).subscribe(async toAccountInfo => {
        if (Object.keys(toAccountInfo).length === 1) {
          const toAccount = Object.keys(toAccountInfo)[0];
          
          if (toAccount !== '') {
            const isSelected = event.node.isSelected();
            const wasCollapsed = !event.node.expanded;

            try {
              if (this.costBasisMethod === 'None') {
                await this.handleLotLevelSelection(event.node, toAccount, isSelected, wasCollapsed);
              } else {
                this.handlePositionLevelSelection(event.node, toAccount, isSelected);
              }
            } finally {
              this.removeSpinner();
            }
          } else {
            this.removeSpinner();
          }
        }
      });
    }
  }

  private async handleLotLevelSelection(node: any, toAccount: string, isSelected: boolean, wasCollapsed: boolean): Promise<void> {
    if (wasCollapsed) {
      node.setExpanded(true);
      await this.waitForDetailGridReady(node);
    }

    this.setLotValues(node, toAccount, isSelected);

    if (wasCollapsed) {
      await this.waitForPositionUpdate(node, toAccount, isSelected);
      node.setExpanded(false);
    }
  }

  private handlePositionLevelSelection(node: any, toAccount: string, isSelected: boolean): void {
    if (!isSelected) {
      node.setDataValue('Shares to move ' + toAccount, '');
      node.setDataValue('Estimated market value ' + toAccount, '');
      return;
    }

    const isRestricted = node.data.restrictionsInfo[toAccount].restriction.isRestricted;
    const isQuantityMismatch = node.data.restrictionsInfo[toAccount].restriction.restrictionText === this.quantityMismatch;
    const isDuplicateRestriction = node.data.restrictionsInfo[toAccount].restriction.restrictionText.startsWith('DUPLICATE');

    if (!isRestricted || isQuantityMismatch || isDuplicateRestriction) {
      const sharesToMove = this.parseSharesToMove(node.data['Available shares']);
      const estMarketValue = this.calculateEstimatedMarketValue(node, sharesToMove);
      
      node.setDataValue('Shares to move ' + toAccount, sharesToMove !== 0 ? sharesToMove.toString() : "");
      node.setDataValue('Estimated market value ' + toAccount, estMarketValue !== 0 ? this.currencyPipe.transform(estMarketValue) : "");
    }
  }

  private setLotValues(node: any, toAccount: string, isSelected: boolean): void {
    const detailGrid = this.gridApi?.getDetailGridInfo(node.detailNode.id);
    const valueToSet = isSelected 
      ? (lotNode: any) => (lotNode.data['Holding Period'].split(' ')[0]).replaceAll(',', '').replace('-', '')
      : () => '';

    detailGrid?.api?.forEachNode(lotNode => {
      lotNode.setDataValue('Lots to move ' + toAccount, valueToSet(lotNode));
    });
  }

  private async waitForDetailGridReady(node: any): Promise<void> {
    return new Promise((resolve) => {
      const checkDetailGrid = () => {
        if (this.gridApi?.getDetailGridInfo(node.detailNode.id)) {
          resolve();
        } else {
          setTimeout(checkDetailGrid, 50);
        }
      };
      checkDetailGrid();
    });
  }

  private async waitForPositionUpdate(node: any, toAccount: string, isSelected: boolean): Promise<void> {
    return new Promise((resolve) => {
      const expectedValue = isSelected 
        ? node.data['Available shares'].split(' ')[0].replaceAll(',', '')
        : '';

      // Listen for the specific cell value change by checking shares to move is set to correct value before stopping spinner and collapsing table which ends operation for manual selection
      const listener = (event: any) => {
        if (event.node.master && event.data['Shares to move ' + toAccount] === expectedValue
        ) {
            this.gridApi?.removeEventListener('cellValueChanged', listener);
            resolve();
        }
      };

      this.gridApi?.addEventListener('cellValueChanged', listener);

      // Fallback timeout with cleanup, set to 10 seconds to avoid indefinite wait should never hit this in normal operation
      setTimeout(() => {
        this.gridApi?.removeEventListener('cellValueChanged', listener);
        resolve();
      }, 10000);
    });
  }

  private parseSharesToMove(availableShares: string): number {
    const shares = (availableShares.split(' ')[0]).replaceAll(',', '');
    return !isNaN(Number(shares)) ? Math.abs(Number(shares)) : 0;
  }

  private calculateEstimatedMarketValue(node: any, sharesToMove: number): number {
    const pricePerShare = node.data['Current price/share'].replaceAll(',', '').replace('$', '');
    if (isNaN(Number(pricePerShare))) return 0;
    
    return sharesToMove * Number(pricePerShare) * node.data['valMultiplier'];
  }

  scrollToHtmlId(id: string, scrollTo: ScrollLogicalPosition = 'start') {
    const htmlElementId = document.getElementById(
      id,
    ) as HTMLInputElement | null;
    setTimeout(function () {
      htmlElementId?.scrollIntoView({ behavior: 'smooth', block: scrollTo });
    }, 0);
  }

  calculateTotals(toAccountInfo: ToAccountInfoById, isSharesToMove: boolean) {
    // Aggregate all totals in one grid walk so footer values and store totals are updated from the same filtered data set.
    const totalsByAccount = Object.keys(toAccountInfo).reduce((totals, accountKey) => {
      totals[accountKey] = {
        total: 0,
        totalEmv: 0,
        totalCostBasis: 0,
      };

      return totals;
    }, {} as Record<string, { total: number; totalEmv: number; totalCostBasis: number; }>);

    this.gridApi?.forEachNode(node => {
      Object.keys(toAccountInfo).forEach((accountKey) => {
        const restricted = node?.data?.restrictionsInfo[accountKey]?.restriction;
        const canIncludeRow = (!restricted?.isRestricted
          || restricted?.restrictionText === this.quantityMismatch
          || restricted?.restrictionText?.startsWith('DUPLICATE'))
          && (node.data['hasError ' + accountKey] ?? 0) < 1;

        if (!canIncludeRow) {
          return;
        }

        const totals = totalsByAccount[accountKey];
        const costBasisValue = node.data['Total cost basis ' + accountKey];
        const sharesToMoveValue = node.data['Shares to move ' + accountKey];
        const estimatedMarketValueValue = node.data['Estimated market value ' + accountKey];
        const costBasisTotal = !costBasisValue || costBasisValue === 'N/A'
          ? 0
          : Number(costBasisValue.replaceAll('$', '').replaceAll(',', ''));
        const sharesToMove = !sharesToMoveValue ? 0 : Number(sharesToMoveValue);
        const estimatedMarketValue = !estimatedMarketValueValue
          ? 0
          : Number(estimatedMarketValueValue.replaceAll('$', '').replaceAll(',', ''));

        totals.total += sharesToMove;
        totals.totalEmv += estimatedMarketValue;
        totals.totalCostBasis += costBasisTotal;
      });
    });

    Object.entries(totalsByAccount).forEach(([accountKey, totals]) => {
      this.updateFooter(accountKey, totals.total, totals.totalEmv, totals.totalCostBasis);
      if (isSharesToMove) {
        this.updateStorePositionTotal(accountKey, totals.total, totals.totalEmv);
      }
    });
  }

  updateFooter(account: string, total: number, totalEmv: number, totalCostBasis: number) {
    if (this.gridApiTotals) {
      this.gridApiTotals?.forEachNode(node => {
        this.isEmptyOrNull(total) ? node.setDataValue('Shares to move ' + account, '') : node.setDataValue('Shares to move ' + account, this.decimalPipe.transform(total, '1.0-5') ?? '');
        this.isEmptyOrNull(totalCostBasis) ? node.setDataValue('Total cost basis ' + account, '') : node.setDataValue('Total cost basis ' + account, this.currencyPipe.transform(totalCostBasis));
        this.isEmptyOrNull(totalEmv) ? node.setDataValue('Estimated market value ' + account, '') : node.setDataValue('Estimated market value ' + account, this.currencyPipe.transform(totalEmv));
      });
    }
  }

  onCostbasisChanged() {
    this.store.select(selectCostBasis).pipe(takeUntil(this.destroy$), withLatestFrom(this.store.select(selectToAccountsInfo))).subscribe(async ([costBasis, toAccounts]) => {
      if (!this.reviewConfirmationPage) {
        // Scroll before the expensive manual/non-manual transition so the user keeps table context while rows are rebuilt.
        const shouldPreScrollToPositionsTable = !this.isEmptyOrNull(costBasis)
          && !this.isEmptyOrNull(this.lastCostBasis)
          && costBasis !== this.lastCostBasis;

        if (shouldPreScrollToPositionsTable) {
          await this.scrollPositionsTableTopBeforeHeavyRender();
        }

        this.addSpinner();
        setTimeout(() => {
          if (!this.isEmptyOrNull(costBasis)) {
            if (costBasis === 'None' && this.lastCostBasis !== 'None') {
              this.costBasisMethod = costBasis;
              this.updateRowDataOnCostBasisChange(toAccounts, true);
              this.expandOrCollapseRows(true);
              this.calculateTotals(toAccounts, true);
              this.setSelectAllHeaderCheckBox();
              this.setRestrictedRowHeight();
            } else if (costBasis !== 'None' && this.lastCostBasis === 'None') {
              this.updateRowDataOnCostBasisChange(toAccounts, false);
              this.expandOrCollapseRows(false);
              this.setSelectAllHeaderCheckBox();
              this.gridApi?.forEachDetailGridInfo(grid => {
                grid?.api?.clearFocusedCell();
                grid.api?.forEachNode(node => {
                  node.setDataValue('Lots to move', '');
                  node.setDataValue('Estimated market value', '');
                });
              });
              this.setRestrictedRowHeight();
            }
            if (costBasis === 'None' && this.lastCostBasis === 'None') {
              this.expandOrCollapseRows(true);
            }
          }
          this.lastCostBasis = costBasis;
          this.stabilizeGridLayout({ syncColumnWidths: true });
        }, 100);
        this.removeSpinner();
      }
    });
  }

  setRestrictedRowHeight(): void {
    this.gridApi?.forEachNode((rowNode) => {
      const restrictionsInfo = rowNode.data?.restrictionsInfo;
      if (restrictionsInfo) {
        const keys = Object.keys(restrictionsInfo);
        for (const key of keys) {
          if (
            restrictionsInfo[key]?.restriction?.isRestricted && this.costBasisMethod === 'None'
          ) {
            rowNode.setRowHeight(positionConstants.tableRestrictedMessageRowHeight);
            break;
          }
          else {
            rowNode.setRowHeight(positionConstants.tableRowHeight);
          }
        }
      }
    });
    this.gridApi?.onRowHeightChanged();
  }

  setSelectAllHeaderCheckBox() {
    (this.gridOptions.rowSelection as any).headerCheckbox = this.costBasisMethod !== 'None';
    this.gridApi?.refreshHeader();
  }

  onPaginationChanged(event: any) {
    const currentPage = this.gridApi?.paginationGetCurrentPage();
    const currentPageSize = this.gridApi?.paginationGetPageSize();

    if (currentPage === undefined || currentPageSize === undefined) {
      return;
    }

    const hasPriorPaginationState = this.lastPage !== -1 && this.lastPageSize !== -1;
    const hasPaginationChanged = this.lastPage !== currentPage || this.lastPageSize !== currentPageSize;
    const previousGridHeight = this.lastPaginationGridHeight;

    this.lastPage = currentPage;
    this.lastPageSize = currentPageSize;

    if (!hasPriorPaginationState || !hasPaginationChanged) {
      this.lastPaginationGridHeight = this.getPositionsTableHeight();
      return;
    }

    // Only re-anchor the view when pagination makes the rendered grid shorter; expanding the grid keeps the current viewport.
    setTimeout(() => {
      const currentGridHeight = this.getPositionsTableHeight();
      const shouldRestoreTableContext = previousGridHeight !== undefined
        && currentGridHeight > 0
        && currentGridHeight < previousGridHeight;

      this.lastPaginationGridHeight = currentGridHeight || previousGridHeight;

      if (shouldRestoreTableContext) {
        this.scrollPositionsTableTop();
      }

      this.scheduleGridWidthSync();

      if (event.newPageSize) {
        this.gridApi?.redrawRows();
      }
    }, 0);
  }

  private getPositionsTableHeight(): number {
    const positionsTable = document.querySelector('.positions-master-grid') as HTMLElement | null;
    return Math.round(positionsTable?.getBoundingClientRect().height ?? 0);
  }

  addExportData() {
    this.gridApi?.forEachNode(masterNode => {
      let currentNodes = masterNode.data['detailRows'];
      masterNode.data['detailRows'] = [];
      this.gridApi?.getDetailGridInfo('detail_' + masterNode.id)?.api?.forEachNode(node => {
        masterNode.data['detailRows'].push(node);
      });

      if (masterNode.data['detailRows'].length === 0) {
        masterNode.data['detailRows'] = currentNodes;
      }

      if (masterNode.data['detailRows'].length === 0) {
        masterNode.data['detailRows'] = masterNode.data['lotDetail'];
      }

    });
  }

  createExportTotalsRow() {
    let totalsExportRow = [
      cell('Totals', 'header'),
      cell('', 'header'),
      cell(this.shares, 'header'),
      cell('', 'header'),
      cell('', 'header'),
    ];

    for (const key in this.toAccountInfo) {
      this.gridApiTotals?.forEachNode(node => {
        totalsExportRow.push(cell(node.data['Shares to move ' + key], 'header'));
        totalsExportRow.push(cell(node.data['Total cost basis ' + key], 'header'));
        totalsExportRow.push(cell(node.data['Estimated market value ' + key], 'header'));
      });
    }
    let response: ExcelRow[] = [
      {
        cells: totalsExportRow
      }
    ];
    return response;
  }

  getExportParams() {
    const exportDate = DateTime.now().toFormat('MM-dd-yyyy') + '_' + DateTime.now().toLocaleString(DateTime.TIME_WITH_SHORT_OFFSET);
    return {
      author: '',
      fileName: 'InternalTransferPositionsDetails_' + this.subAccountId + '_' + exportDate,
      sheetName: 'Sheet1',
      appendContent: this.createExportTotalsRow()
    };
  }

  exportPositionData() {
    this.store.select(selectSubAccountId).pipe(takeUntil(this.destroy$)).subscribe(subAccountId => { this.subAccountId = subAccountId; });
    this.addExportData();
    this.gridApi?.exportDataAsExcel(this.getExportParams());
  }

  getHeaderForExportFile() {
    let headerList = [
      cell('', 'header'),
      cell('Acquired Date', 'header'),
      cell(' ', 'header'),
      cell(' ', 'header'),
      cell(' ', 'header'),
    ];
    for (const key in this.toAccountInfo) {
      headerList.push(cell(' ', 'header'));
      headerList.push(cell(' ', 'header'));
      headerList.push(cell(' ', 'header'));
    }
    let response: ExcelRow =
    {
      cells: headerList
    };
    return response;
  }

  getBodyForExportFile(params: any, record: any) {
    let bodyList = [
      cell('', 'body'),
      cell(record?.data?.['Acquired date'] ?? record?.['acquiredDate'], 'body'),
      cell(record?.data?.['Holding Period'] ?? this.decimalPipe.transform(record.lotQuantity, '1.0-6') + ' (' + record?.['holdingPeriod'].toLowerCase() + '-term' + ')', 'body'),
      cell(record?.data?.['Current price/share'] ?? params?.node?.data?.['Current price/share'], 'body'),
      cell(record?.data?.['Cost Basis'] ?? this.currencyPipe.transform(record?.['costBasis']), 'body'),
    ];

    for (const key in this.toAccountInfo) {
      bodyList.push(cell(record?.data?.['Lots to move ' + key] ?? '', 'body'));
      bodyList.push(cell(record?.data?.['TotalCostBasis ' + key] ?? '', 'body'));
      bodyList.push(cell(record?.data?.['Estimated market value ' + key] ?? '', 'body'));
    }
    let response: ExcelRow =
    {
      cells: bodyList
    };
    return response;
  }

  public defaultExcelExportParams: ExcelExportParams = {
    getCustomContentBelowRow: (params: any) => {
      return [
        this.getHeaderForExportFile()
      ].concat(
        (params.node.data['detailRows']).map((record: any) => {
          return this.getBodyForExportFile(params, record);
        }),
        { cells: [] }
      );
    },
    columnWidth: 155,
  };


  public onGridReadyTotals(params: GridReadyEvent) {
    this.gridOptionsTotals = params;
    this.gridApiTotals = params.api;
    this.gridColumnApiTotals = params.api;
    this.gridApiTotals.setGridOption("headerHeight", 0);
    this.gridApiTotals?.redrawRows();
    this.gridApiTotals?.forEachNode(node => {
      node.setDataValue('Available shares', this.shares);
    });
    this.store.select(selectToAccountsInfo).pipe(take(1)).subscribe(toAccountInfo => {
      this.calculateTotals(toAccountInfo, false);
    });
    this.scheduleGridWidthSync();
  }

  onNewColumnsLoaded(event: NewColumnsLoadedEvent) {
    this.fitColumnsToAvailableWidth();
    this.columnDefs.forEach((lotColumn) => {
      if ('groupId' in lotColumn && typeof (lotColumn.groupId) === 'string' && !this.firsttoAccountColumn)
        this.firsttoAccountColumn = lotColumn.groupId;
    });
  }

  isNumberOrEmptyString(value: string | number): boolean {
    return value === '' || this.isNumber(value);
  }

  isNumber(value: string | number): boolean {
    return (!!value && !isNaN(Number(value.toString())));
  }

  onPositionsCellValueChanged(params: CellValueChangedEvent) {
    const isSharesToMoveUpdated = (params?.colDef?.field?.includes('Shares to move') ?? false)
      && params.newValue !== params.oldValue
      && (!!params.newValue || !!params.oldValue);
    this.store.select(selectToAccountsInfo).pipe(take(1)).subscribe(toAccountInfo => {
      this.calculateTotals(toAccountInfo, isSharesToMoveUpdated);
    });
    if (isSharesToMoveUpdated) {
      let toAccountKey = params?.colDef?.field?.toString().split(' ')[3];
      params.node.setDataValue('nodeChanged ' + toAccountKey, true);
      this.updateStorePosition(params);
      this.handleSetToAverageMessageCounter(params);
      if (this.costBasisMethod !== 'None') {
        this.clearEstimatedMarketValWithError(params);
      }
    }

    if (isSharesToMoveUpdated && this.costBasisMethod === 'None') {
      let toAccountKey = params?.colDef?.field?.toString().split(' ')[3];
      let totalCostBasis = this.calculateTotalCostBasis(params.node.id, toAccountKey);
      params.node.setDataValue('Total cost basis ' + toAccountKey, totalCostBasis);
    }

  }

  calculateTotalCostBasis(detailGridId: string | undefined, toAccountKey: string | undefined) {
    if (detailGridId == undefined || toAccountKey == undefined) {
      return '';
    }
    let totalCostBasis = 0;
    this.gridApi?.getDetailGridInfo(detailGridId + '')?.api?.forEachNode(node => {
      let lotTotalCostBasis = node.data['TotalCostBasis ' + toAccountKey] == undefined ? 0 : Number(node.data['TotalCostBasis ' + toAccountKey].replaceAll('$', '').replaceAll(',', ''));
      totalCostBasis = lotTotalCostBasis + totalCostBasis;
    });
    if (totalCostBasis == 0) {
      return '';
    } else {
      return this.currencyPipe.transform(totalCostBasis);
    }
  }

  changeErrorMessage(error: string) {
    if (error === positionConstants.notValidReorganizationPositionErrorMessage) {
      return positionConstants.reorganizationPositionErrorMessage;
    }
    if (error === positionConstants.notValidShortPositionErrorMessage) {
      return positionConstants.shortPositionErrorMessage;
    }
    if (error?.startsWith('DUPLICATE')) {
      if (this.isMF30DaySpecificDuplicateRestrictionText(error)) {
        return "Manual selection is not available during a 30-day minimum hold. Use another cost basis method.";
      }
      return error.replace('DUPLICATE: ', '') + " - " + "Given this restriction you are not allowed to move lots for this position";
    }
    return error;
  }


  clearEstimatedMarketValWithError(params: CellValueChangedEvent) {
    let keys = Object.keys(this.toAccountInfo ?? {});
    keys.forEach(key => {
      if (params.node.data['hasError ' + key] > 0) {
        params.node.setDataValue('Estimated market value ' + key, '');
      }
    });
  }

  updateStorePositionTotal(toAccountId: string, total: number, emvTotal: number) {
    this.store.select(selectMultipleToAccountsPositionLotTableData).pipe(take(1)).subscribe(rowDataById => {
      const byId: RowDataById = {};
      Object.entries(rowDataById).forEach(([key, rowData]) => {
        if (key === toAccountId) {
          let data = {
            positionData: rowData.positionData,
            sharesToMoveTotal: total,
            estimatedMarketValueTotal: emvTotal,
            nodeCostBasis: this.costBasisMethod ?? ''
          };
          byId[key] = data;
        } else {
          byId[key] = rowData;
        }
      });
      this.store.dispatch(InternalTransfersActions.itUpdateRowData(byId));
    });
  }

  updateStoreAllPositions() {
    this.store.select(selectMultipleToAccountsPositionLotTableData).pipe(take(1)).subscribe(rowDataById => {
      const byId: RowDataById = {};
      Object.entries(rowDataById).forEach(([key, rowData]) => {
        let positionData = rowData?.positionData?.map(position => {
          const lotDetails = position['lotDetail'];
          return {
            ...position,
            'lotDetail': this.costBasisMethod === 'None' ? lotDetails : this.clearStoreLotsToMove(lotDetails)

          };
        });
        let data = {
          positionData: positionData,
          sharesToMoveTotal: rowData?.sharesToMoveTotal,
          estimatedMarketValueTotal: rowData?.estimatedMarketValueTotal,
          nodeCostBasis: this.costBasisMethod ?? '',
        };
        byId[key] = data;
      });
      if (!byId) {
        this.store.dispatch(InternalTransfersActions.itUpdateRowData(byId));
      }
    });
  }

  addSpinner() {
    setTimeout(() => {
      this.gridApi?.setGridOption('loading', true);
    }, 100);
  }
  removeSpinner() {
    setTimeout(() => {
      this.gridApi?.setGridOption('loading', false);
    }, 1000);
  }


  getErrorStatus(key: string, name: string) {
    let error = false;
    this.gridApi?.forEachNode(node => {
      if (node.data['Symbol'] === name) {
        if (node.data['hasError ' + key] > 0) {
          error = true;
        }
        else {
          error = false;
        }
      }
    });

    if (!error) {
      this.gridApi?.forEachDetailGridInfo(grid => {
        grid.api?.forEachNode(row => {
          if (row.data['Symbol'] === name) {
            if (row.data['lotHasError ' + key] > 0) {
              error = true;
            }
          }
        });
      });
    }
    return error;
  }

  updateStorePosition(params: CellValueChangedEvent) {
    if (this.isNumberOrEmptyString(params.newValue)) {
      const symbol = params.data['Symbol'];
      const columnFieldSplit = params.column.getColId()?.split(' ');
      const toAccountId = columnFieldSplit[columnFieldSplit.length - 1];
      this.store.select(selectMultipleToAccountsPositionLotTableData).pipe(take(1)).subscribe(rowDataById => {
        const byId: RowDataById = {};
        Object.entries(rowDataById).forEach(([key, rowData]) => {
          if (key === toAccountId) {
            let positionData = rowData?.positionData?.map(position => {
              if (position['Symbol'] === symbol) {
                const lotDetails = position['lotDetail'];
                let error = this.getErrorStatus(key, position['Symbol']);
                return {
                  ...position,
                  'Shares to move': params.newValue,
                  'Estimated market value': params.data[`Estimated market value ${key}`],
                  'Total cost basis': this.calculateTotalCostBasis(params.node.id, toAccountId),
                  'lotDetail': this.costBasisMethod === 'None' ? lotDetails : this.clearStoreLotsToMove(lotDetails),
                  'hasError': error
                };
              } else {
                return { ...position };
              }
            });
            let data = {
              positionData: positionData,
              sharesToMoveTotal: rowData?.sharesToMoveTotal,
              estimatedMarketValueTotal: rowData?.estimatedMarketValueTotal,
              nodeCostBasis: this.costBasisMethod ?? '',
            };
            byId[key] = data;
          } else {
            byId[key] = rowData;
          }
        });
        this.store.dispatch(InternalTransfersActions.itUpdateRowData(byId));
      });
    }
  }

  clearStoreLotsToMove(lots: LotDetails[]) {
    let lotData = lots.map(lot => {
      return {
        ...lot,
        'lotsToMove': '',
        'lotHasError': 0
      };
    });
    return lotData;
  }

  handleSetToAverageMessageCounter(params: CellValueChangedEvent): void {
    const oldValue = params.oldValue;
    const newValue = params.newValue;
    const setToAverage = params.data.setToAverage;
    if (setToAverage && !oldValue && !!newValue) {
      this.showSetToAverageMessageCounter++;
    } else if (setToAverage && !newValue && !!oldValue) {
      this.showSetToAverageMessageCounter--;
    }
  }

  expandOrCollapseRows(expand: boolean, scrollToTop: boolean = false) {
    this.gridApi?.forEachNode((rowNode, index) => {
      if (expand && this.hasDuplicateRestrictionInRow(rowNode?.data)) {
        rowNode.setExpanded(false);
        return;
      }
      rowNode.setExpanded(expand);
    });
    this.expanded = expand;
    const checkbox = document.getElementById(
      'expandAllId',
    ) as HTMLInputElement | null;
    if (checkbox !== null) {
      checkbox!.checked = expand;
    }
    this.stabilizeGridLayout({ scrollToTop });
  }

  updateRowDataOnCostBasisChange(toAccountInfo: ToAccountInfoById, manualFlow: boolean,) {
    let rowData: PositionDetailsForMultiToAccount[] = this.getUpdatedPositionLotDetailsOnCostBasisChange(this.positionsDetails, manualFlow);
    this.gridApi?.setGridOption("rowData", rowData);
    this.updateStorePositionLotDetailsOnCostBasisChange(manualFlow);

    if (!manualFlow) {
      this.setTotalCostBasisNA(toAccountInfo);
    }
    this.stabilizeGridLayout({ syncColumnWidths: true });
  }

  public getUpdatedPositionLotDetailsOnCostBasisChange(positionsLotDetails: PositionDetailsForMultiToAccount[], manualFlow: boolean): any[] {
    return positionsLotDetails.map(position => {
      var positionColumn: Record<string, any> = {
        Symbol: position.symbol,
        Name: position.setToAverage ? `${this.convertToCamelCase(position.symbolName)} (Set to Average)` : this.convertToCamelCase(position.symbolName),
        RowHeight: positionConstants.tableRowHeight,
        'Available shares': `${this.decimalPipe.transform(position.totalQuantity, '1.0-5')} (${position.numberOfLots} ${position.numberOfLots === 1 ? 'lot' : 'lots'})`,
        'Current price/share': position.currentPricePerShare,
        'Cost basis': position.costBasis,
        'lotDetail': position.lots,
        'setToAverage': position.setToAverage,
        'Quantity': position.quantity,
        'cmtSequenceId': position.cmtSequenceId,
        'valMultiplier': position.valMultiplier,
        'schwabSecurityId': position.schwabSecurityId,
        'detailRows': [],
        'currentAvailableShares': Number(position.totalQuantity),
        'restrictionsInfo': position.toAccountPositionDetails
      };
      this.store.select(selectMultipleToAccountsPositionLotTableData).pipe(take(1)).subscribe(rowData => {
        Object.entries(rowData).forEach(([key, entry]) => {
          const storePosition = entry?.positionData?.find(data => data.schwabSecurityId === positionColumn['schwabSecurityId']);

          // if switching from any other cost basis method to manual, should clear everything (but there should only be data at position level to clear)
          if (!!storePosition && !!storePosition['Shares to move'] && manualFlow) {

            positionColumn[`Shares to move ${key}`] = '';
            positionColumn[`Estimated market value ${key}`] = '';
            positionColumn[`Total cost basis ${key}`] = '';
            this.showSetToAverageMessageCounter = 0;
          }
          // if switching from manual to any other cost basis method, clear all lot data, but keep position
          else if (!!storePosition && !!storePosition['Shares to move'] && !manualFlow) {
            const storeLot = storePosition?.lotDetail?.find((lot: { [x: string]: any; }) => lot['lotId'] === positionColumn['lotId']);
            if (!!storeLot && !!storeLot['lotsToMove']) {
              positionColumn[`Lots to move ${key}`] = '';
            }

            positionColumn[`Shares to move ${key}`] = storePosition['Shares to move'];
            positionColumn[`Estimated market value ${key}`] = storePosition['Estimated market value'];
            positionColumn[`Total cost basis ${key}`] = storePosition['Total cost basis'];
          }
        });
      });
      return positionColumn;
    });
  };

  public updateStorePositionLotDetailsOnCostBasisChange(manualFlow: boolean) {
    const byId: RowDataById = {};
    this.store.select(selectMultipleToAccountsPositionLotTableData).pipe(take(1)).subscribe(rowData => {
      Object.entries(rowData).forEach(([key, entry]) => {
        // if switching from any other cost basis method to manual, should clear everything (but there should only be data at position level to clear)
        if (manualFlow) {
          let positionData = entry?.positionData?.map(position => {
            const lotDetails = position['lotDetail'];
            return {
              ...position,
              hasError: false,
              'Shares to move': '',
            };
          });

          let data = {
            positionData: positionData,
            sharesToMoveTotal: 0,
            estimatedMarketValueTotal: entry?.estimatedMarketValueTotal,
            nodeCostBasis: this.costBasisMethod ?? '',
          };
          byId[key] = data;
        }
        // if switching from manual to any other cost basis method, clear all lot data, but keep position
        else if (!manualFlow) {
          let positionData = entry?.positionData?.map(position => {
            const lotDetails = position['lotDetail'];
            return {
              ...position,
              hasError: false,
              'lotDetail': this.clearStoreLotsToMove(lotDetails)
            };
          });

          let data = {
            positionData: positionData,
            sharesToMoveTotal: entry.sharesToMoveTotal,
            estimatedMarketValueTotal: entry?.estimatedMarketValueTotal,
            nodeCostBasis: this.costBasisMethod ?? '',
          };
          byId[key] = data;
        }
      });
    });
    this.store.dispatch(InternalTransfersActions.itUpdateRowData(byId));
  }

  setTotalCostBasisNA(toAccountInfo: ToAccountInfoById) {
    if (this.costBasisMethod !== 'None') {
      this.gridApi?.forEachNode(node => {
        for (const key in toAccountInfo) {
          node.setDataValue(('Total cost basis ' + key), 'N/A');
        }
      });
    }
  }

  handleCheckBoxColumn(toAccountInfo: ToAccountInfoById) {
    if (this.gridColumnApi && Object.keys(toAccountInfo).length === 1 && !this.totalDistSelected) {
      setTimeout(() => {
        this.gridColumnApi?.setColumnsVisible(['ag-Grid-SelectionColumn'], true);
        this.gridApiTotals?.setColumnsVisible(['ag-Grid-SelectionColumn'], true);
        this.detailCellRendererParams?.detailGridOptions?.setColumnVisible(0, true);
        this.setSelectAllHeaderCheckBox();
        this.gridApi?.forEachNode(node => this.setRowSelected(node, Object.keys(toAccountInfo)[0]));
      }, 10);

    } else {
      setTimeout(() => {
        this.gridColumnApi?.setColumnsVisible(['ag-Grid-SelectionColumn'], false);
        this.gridApiTotals?.setColumnsVisible(['ag-Grid-SelectionColumn'], false);
        this.detailCellRendererParams?.detailGridOptions?.setColumnVisible(0, false);
      }, 10);
    }
  }

  AddRemoveToAccountColumns() {
    if (this.toAccountColumnsSyncInitialized) {
      this.applyToAccountColumns(this.toAccountInfo ?? {});
      return;
    }

    this.toAccountColumnsSyncInitialized = true;
    this.store.select(selectToAccountsInfo).pipe(takeUntil(this.destroy$)).subscribe(toAccountInfo => {
      this.applyToAccountColumns(toAccountInfo);
    });
  }

  // Centralize all to-account column changes here so the master grid, totals grid, and detail grids stay in lockstep.
  private applyToAccountColumns(toAccountInfo: ToAccountInfoById) {
    let numOfAccounts = Object.keys(toAccountInfo).length;
    if (this.accountsInContext !== numOfAccounts) {
      this.addSpinner();
      this.accountsInContext = numOfAccounts;
    }
    this.handleCheckBoxColumn(toAccountInfo);
    this.AddToAccountColumns(toAccountInfo);
    this.RemoveToAccountColumns(toAccountInfo);
    this.columnDefs = this.defColumnDefs;
    if (this.gridApi) this.gridApi?.setGridOption('columnDefs', this.defColumnDefs);
    if (this.gridApiTotals) this.gridApiTotals?.setGridOption('columnDefs', this.defColumnDefs);
    this.setTotalCostBasisNA(toAccountInfo);
    this.calculateEMV(toAccountInfo);
    this.calculateTotals(toAccountInfo, false);
    this.stabilizeGridLayout({ syncColumnWidths: true });
  }

  // Batch the row-height, header, and width work into a small number of deferred passes so AG Grid settles cleanly after data changes.
  private stabilizeGridLayout(options: { syncColumnWidths?: boolean, scrollToTop?: boolean } = {}) {
    this.pendingLayoutOptions.syncColumnWidths = this.pendingLayoutOptions.syncColumnWidths || !!options.syncColumnWidths;
    this.pendingLayoutOptions.scrollToTop = this.pendingLayoutOptions.scrollToTop || !!options.scrollToTop;

    this.scheduledLayoutPassTimeouts.forEach(timeoutId => clearTimeout(timeoutId));
    this.scheduledLayoutPassTimeouts = [];

    const runLayoutPass = () => {
      const layoutOptions = { ...this.pendingLayoutOptions };

      this.gridApi?.onRowHeightChanged();
      this.gridApi?.refreshHeader();
      this.gridApi?.redrawRows();
      this.gridApiTotals?.refreshHeader();
      this.gridApiTotals?.redrawRows();

      if (layoutOptions.syncColumnWidths) {
        this.fitColumnsToAvailableWidth();
      }
    };

    this.scheduledLayoutPassTimeouts.push(setTimeout(runLayoutPass, 0));
    this.scheduledLayoutPassTimeouts.push(setTimeout(() => {
      runLayoutPass();
      this.pendingLayoutOptions = { syncColumnWidths: false, scrollToTop: false };
      this.scheduledLayoutPassTimeouts = [];
    }, 50));

    if (this.pendingLayoutOptions.scrollToTop) {
      this.schedulePositionsTableTopScroll();
    }
  }

  private schedulePositionsTableTopScroll() {
    if (this.scrollToTopAfterLayoutTimeout) {
      clearTimeout(this.scrollToTopAfterLayoutTimeout);
    }

    this.scrollToTopAfterLayoutTimeout = setTimeout(() => {
      this.scrollPositionsTableTop('smooth');
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.scrollPositionsTableTop();
        });
      });
    }, 250);
  }

  private async scrollPositionsTableTopBeforeHeavyRender(duration: number = 550): Promise<void> {
    this.scrollPositionsTableTop('smooth');
    await new Promise(resolve => setTimeout(resolve, duration));

    if (this.positionsTableTopScrollAnimationFrame !== undefined) {
      cancelAnimationFrame(this.positionsTableTopScrollAnimationFrame);
      this.positionsTableTopScrollAnimationFrame = undefined;
    }
  }

  private handleReviewReturnScroll() {
    this.reviewReturnRecoveryTimeouts.forEach(timeoutId => clearTimeout(timeoutId));
    this.reviewReturnRecoveryTimeouts = [];

    this.scrollPositionsTableTop('smooth');

    [0, 300, 700].forEach((delay) => {
      const timeoutId = setTimeout(() => {
        if (delay > 0) {
          this.scrollPositionsTableTop();
        }

        this.bindStickyHeaderScroll();
        this.updateStickyHeaderTopOffset();
        this.scheduleGridWidthSync();
        this.updateStickyHeaderVisibility();
      }, delay);

      this.reviewReturnRecoveryTimeouts.push(timeoutId);
    });
  }

  private scrollPositionsTableTop(behavior: ScrollBehavior = 'auto') {
    const scrollTarget = document.getElementById('position-table-header')
      ?? document.getElementById('position-lots-table')
      ?? document.getElementById('table-toolbar');
    const scrollContainer = document.getElementById('mm-content');
    const positionsTableTopOffset = 120;

    if (!scrollTarget) {
      return;
    }

    if (scrollContainer) {
      const containerRect = scrollContainer.getBoundingClientRect();
      const targetRect = scrollTarget.getBoundingClientRect();
      const scrollTop = Math.max(scrollContainer.scrollTop + targetRect.top - containerRect.top - positionsTableTopOffset, 0);

      if (behavior === 'smooth') {
        this.animateVerticalScroll(scrollContainer, scrollTop, 550);
        return;
      }

      scrollContainer.scrollTo({ top: scrollTop, behavior });
      return;
    }

    const scrollTop = Math.max(window.scrollY + scrollTarget.getBoundingClientRect().top - positionsTableTopOffset, 0);

    if (behavior === 'smooth') {
      this.animateVerticalScroll(window, scrollTop, 550);
      return;
    }

    window.scrollTo({ top: scrollTop, behavior });
  }

  private animateVerticalScroll(target: HTMLElement | Window, targetTop: number, duration: number) {
    if (this.positionsTableTopScrollAnimationFrame !== undefined) {
      cancelAnimationFrame(this.positionsTableTopScrollAnimationFrame);
    }

    const startTop = target instanceof Window ? window.scrollY : target.scrollTop;
    const distance = targetTop - startTop;
    const startTime = performance.now();

    const easeInOutCubic = (progress: number) => progress < 0.5
      ? 4 * progress * progress * progress
      : 1 - Math.pow(-2 * progress + 2, 3) / 2;

    const step = (currentTime: number) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const nextTop = startTop + distance * easeInOutCubic(progress);

      if (target instanceof Window) {
        target.scrollTo({ top: nextTop, behavior: 'auto' });
      } else {
        target.scrollTo({ top: nextTop, behavior: 'auto' });
      }

      if (progress < 1) {
        this.positionsTableTopScrollAnimationFrame = requestAnimationFrame(step);
      } else {
        this.positionsTableTopScrollAnimationFrame = undefined;
      }
    };

    this.positionsTableTopScrollAnimationFrame = requestAnimationFrame(step);
  }

  private scheduleGridWidthSync(delay: number = 0) {
    if (this.scheduledGridWidthSyncTimeout) {
      clearTimeout(this.scheduledGridWidthSyncTimeout);
    }

    this.scheduledGridWidthSyncTimeout = setTimeout(() => {
      this.scheduledGridWidthSyncTimeout = undefined;
      this.fitColumnsToAvailableWidth();
    }, delay);
  }

  // Size the master grid first, then mirror those widths into the totals row and any open detail grids.
  private fitColumnsToAvailableWidth() {
    this.refreshStickyHeaderDomRefs();

    const displayedMasterColumns = this.gridColumnApi?.getAllDisplayedColumns?.() ?? [];
    const displayedTotalsColumns = this.gridApiTotals?.getAllDisplayedColumns?.() ?? [];

    if (this.gridApi && displayedMasterColumns.length > 0) {
      this.gridApi.sizeColumnsToFit();
    } else if (this.gridApiTotals && displayedTotalsColumns.length > 0) {
      this.gridApiTotals.sizeColumnsToFit();
    }

    if (this.gridColumnApi) {
      this.detailCellRendererParams.detailGridOptions?.sizeColumnsToMatchMasterTable(this.gridColumnApi);
      this.syncOpenDetailGridColumnWidths();
    }

    this.updateStickyHeaderColumns();
    this.updateStickyHeaderVisibility();
  }

  // Build the custom sticky header from the live AG Grid column state so ordering, width, and context stay accurate while scrolling.
  private updateStickyHeaderColumns() {
    this.refreshStickyHeaderDomRefs();

    const domColumns = this.getStickyHeaderColumnsFromDom();
    const displayedColumns = this.gridColumnApi?.getAllDisplayedColumns?.() ?? [];
    const domColumnsById = new Map(
      domColumns.map((column) => [column.colId, column] as const)
    );

    this.stickyHeaderColumns = displayedColumns
      .map((column: any): StickyHeaderColumn | undefined => {
        const colDef = column.getColDef?.() as ColDef | undefined;
        const colId = column.getColId?.() ?? colDef?.colId ?? colDef?.field;
        const domColumn = colId ? domColumnsById.get(colId) : undefined;
        const width = domColumn?.width ?? column.getActualWidth?.() ?? 0;
        const configuredAlignment = colDef ? this.getStickyHeaderAlignment(column, colDef) : 'left';
        const headerLabel = colDef ? this.getStickyHeaderLabel(column, colDef) : '';
        const parentLabel = this.getStickyHeaderParentLabel(column);

        if (!colDef || !colId || width <= 0) {
          return undefined;
        }

        return {
          colId,
          label: headerLabel,
          width,
          alignment: domColumn?.alignment === 'right' || configuredAlignment === 'right' ? 'right' : 'left',
          accountContext: this.getStickyHeaderAccountContext(headerLabel, parentLabel),
        };
      })
      .filter((column: StickyHeaderColumn | undefined): column is StickyHeaderColumn => !!column);

    const measuredTotalWidth = this.stickyHeaderColumns.reduce((totalWidth, column) => totalWidth + column.width, 0);
    const renderedHeaderWidth = this.masterGridHeaderContainerElement?.scrollWidth
      || this.masterGridHeaderContainerElement?.getBoundingClientRect().width
      || this.masterGridCenterContainerElement?.scrollWidth
      || this.masterGridCenterContainerElement?.getBoundingClientRect().width
      || this.masterGridLeafHeaderRowElement?.scrollWidth
      || this.masterGridLeafHeaderRowElement?.getBoundingClientRect().width
      || 0;

    this.stickyHeaderTotalWidth = Math.max(measuredTotalWidth, renderedHeaderWidth);
    this.bindStickyHeaderHorizontalScroll();
  }

  private getStickyHeaderColumnsFromDom(): StickyHeaderColumn[] {
    const headerCells = Array.from(
      this.masterGridLeafHeaderRowElement?.querySelectorAll('.ag-header-cell') ?? []
    ) as HTMLElement[];

    return headerCells
      .map((cell, index): StickyHeaderColumn | undefined => {
        const width = cell.getBoundingClientRect().width;
        const label = cell.innerText.trim();
        const colId = cell.getAttribute('col-id') ?? `sticky-header-${index}`;
        const labelContainer = cell.querySelector('.ag-header-cell-label') as HTMLElement | null;
        const headerText = cell.querySelector('.ag-header-cell-text') as HTMLElement | null;
        const justifyContent = labelContainer ? getComputedStyle(labelContainer).justifyContent : '';
        const textAlign = headerText ? getComputedStyle(headerText).textAlign : '';
        const alignment: 'left' | 'right' = cell.classList.contains('ag-right-aligned-header')
          || justifyContent.includes('end')
          || textAlign === 'right'
          ? 'right'
          : 'left';

        if (width <= 0) {
          return undefined;
        }

        return {
          colId,
          label,
          width,
          alignment,
        };
      })
      .filter((column: StickyHeaderColumn | undefined): column is StickyHeaderColumn => !!column);
  }

  private getStickyHeaderAlignment(column: any, colDef: ColDef): 'left' | 'right' {
    const headerName = typeof colDef.headerName === 'string' ? colDef.headerName.trim() : '';
    const fieldName = typeof colDef.field === 'string' ? colDef.field.trim() : '';
    const headerClass = typeof colDef.headerClass === 'string' ? colDef.headerClass : '';
    const columnTypes = Array.isArray(colDef.type)
      ? colDef.type
      : typeof colDef.type === 'string'
        ? [colDef.type]
        : [];

    if (STICKY_HEADER_RIGHT_ALIGNED_COLUMNS.has(headerName) || STICKY_HEADER_RIGHT_ALIGNED_COLUMNS.has(fieldName)) {
      return 'right';
    }

    if (headerClass.includes('ag-right-aligned-header') || columnTypes.includes('rightAligned')) {
      return 'right';
    }

    return 'left';
  }

  private getStickyHeaderLabel(column: any, colDef: ColDef): string {
    const baseLabel = typeof colDef.headerName === 'string' && colDef.headerName.trim().length > 0
      ? colDef.headerName.trim()
      : typeof colDef.field === 'string'
        ? colDef.field
        : '';

    if (this.detailGridTopContextActive && baseLabel === this.colNames.positionSymbol && this.detailGridTopContextSymbol) {
      return `${this.colNames.positionSymbol} (${this.detailGridTopContextSymbol})`;
    }

    if (this.detailGridTopContextActive && baseLabel === this.colNames.positionName) {
      return this.colNames.acquiredDate;
    }

    if (!baseLabel) {
      return '';
    }

    const parentLabel = this.getStickyHeaderParentLabel(column);

    if (parentLabel) {
      return baseLabel;
    }

    return baseLabel;
  }

  private getStickyHeaderParentLabel(column: any): string {
    const parent = column.getParent?.();

    if (!parent) {
      return '';
    }

    const groupDefinition = parent.getColGroupDef?.() ?? parent.getProvidedColumnGroup?.()?.getColGroupDef?.();

    return typeof groupDefinition?.headerName === 'string'
      ? groupDefinition.headerName.trim()
      : '';
  }

  private getStickyHeaderAccountContext(headerLabel: string, parentLabel: string): string {
    if (headerLabel !== this.colNames.totalCostBasis || !parentLabel) {
      return '';
    }

    const labelParts = parentLabel.split(' - ');
    return labelParts[labelParts.length - 1].trim() || '';
  }

  private removeStickyHeaderListener(target: { removeEventListener?: (type: string, listener: EventListenerOrEventListenerObject) => void } | null, listener: EventListenerOrEventListenerObject) {
    if (target && typeof target.removeEventListener === 'function') {
      target.removeEventListener('scroll', listener);
    }
  }

  private refreshStickyHeaderDomRefs() {
    this.stickyHeaderViewportElement = document.querySelector('.positions-sticky-header__viewport') as HTMLElement | null;
    this.stickyHeaderRowElement = document.querySelector('.positions-sticky-header__row') as HTMLElement | null;
    this.stickyBottomScrollViewportElement = document.querySelector('.positions-bottom-scroll-helper__viewport') as HTMLElement | null;
    this.positionsTableBodyElement = document.querySelector('.positions-table-shell__body') as HTMLElement | null;
    this.masterGridHeaderElement = document.querySelector('.positions-master-grid .ag-header') as HTMLElement | null;
    this.masterGridElement = document.querySelector('.positions-master-grid') as HTMLElement | null;
    this.masterGridCenterViewportElement = document.querySelector('.positions-master-grid .ag-center-cols-viewport') as HTMLElement | null;
    this.masterGridHeaderViewportElement = document.querySelector('.positions-master-grid .ag-header-viewport') as HTMLElement | null;
    this.masterGridHeaderContainerElement = document.querySelector('.positions-master-grid .ag-header-container') as HTMLElement | null;
    this.masterGridCenterContainerElement = document.querySelector('.positions-master-grid .ag-center-cols-container') as HTMLElement | null;
    this.masterGridLeafHeaderRowElement = document.querySelector('.positions-master-grid .ag-header .ag-header-row:last-child') as HTMLElement | null;
    this.totalsHorizontalScrollbarElement = document.querySelector('.positions-totals-grid .ag-body-horizontal-scroll') as HTMLElement | null;
    this.totalsHorizontalScrollViewportElement = document.querySelector('.positions-totals-grid .ag-body-horizontal-scroll-viewport') as HTMLElement | null;
  }

  private scheduleStickyHeaderRefresh(options: { visibility?: boolean, context?: boolean } = {}) {
    this.pendingStickyHeaderRefresh.visibility = this.pendingStickyHeaderRefresh.visibility || !!options.visibility;
    this.pendingStickyHeaderRefresh.context = this.pendingStickyHeaderRefresh.context || !!options.context;

    if (this.stickyHeaderRefreshAnimationFrame !== undefined) {
      return;
    }

    this.stickyHeaderRefreshAnimationFrame = requestAnimationFrame(() => {
      const shouldRefreshVisibility = this.pendingStickyHeaderRefresh.visibility;
      const shouldRefreshContext = this.pendingStickyHeaderRefresh.context;

      this.stickyHeaderRefreshAnimationFrame = undefined;
      this.pendingStickyHeaderRefresh = { visibility: false, context: false };

      if (shouldRefreshVisibility) {
        this.updateStickyHeaderVisibility();
        return;
      }

      if (shouldRefreshContext) {
        this.updateStickyHeaderContextUnderHeader();
      }
    });
  }


  private bindStickyHeaderScroll() {
    const nextScrollContainer = document.getElementById('mm-content');

    if (this.stickyHeaderScrollContainer === nextScrollContainer) {
      this.updateStickyHeaderVisibility();
      return;
    }

    this.removeStickyHeaderListener(this.stickyHeaderScrollContainer, this.stickyHeaderScrollHandler);

    this.stickyHeaderScrollContainer = nextScrollContainer;
    this.stickyHeaderScrollContainer?.addEventListener('scroll', this.stickyHeaderScrollHandler, { passive: true });
    this.updateStickyHeaderTopOffset();
    this.updateStickyHeaderVisibility();
  }

  private bindStickyHeaderHorizontalScroll() {
    this.refreshStickyHeaderDomRefs();

    const nextStickyHeaderHorizontalAlignmentElement = this.masterGridHeaderViewportElement ?? this.masterGridCenterViewportElement;
    const nextStickyHeaderHorizontalScrollElement = this.totalsHorizontalScrollViewportElement ?? nextStickyHeaderHorizontalAlignmentElement;

    if (
      this.stickyHeaderHorizontalScrollElement === nextStickyHeaderHorizontalScrollElement
      && this.stickyHeaderHorizontalAlignmentElement === nextStickyHeaderHorizontalAlignmentElement
    ) {
      this.syncStickyHeaderViewportFromGrid();
      return;
    }

    this.removeStickyHeaderListener(this.stickyHeaderHorizontalScrollElement, this.stickyHeaderHorizontalScrollHandler);
    if (this.stickyHeaderHorizontalAlignmentElement && this.stickyHeaderHorizontalAlignmentElement !== this.stickyHeaderHorizontalScrollElement) {
      this.removeStickyHeaderListener(this.stickyHeaderHorizontalAlignmentElement, this.stickyHeaderHorizontalScrollHandler);
    }

    this.stickyHeaderHorizontalAlignmentElement = nextStickyHeaderHorizontalAlignmentElement;
    this.stickyHeaderHorizontalScrollElement = nextStickyHeaderHorizontalScrollElement;

    this.stickyHeaderHorizontalScrollElement?.addEventListener('scroll', this.stickyHeaderHorizontalScrollHandler, { passive: true });
    if (this.stickyHeaderHorizontalAlignmentElement && this.stickyHeaderHorizontalAlignmentElement !== this.stickyHeaderHorizontalScrollElement) {
      this.stickyHeaderHorizontalAlignmentElement.addEventListener('scroll', this.stickyHeaderHorizontalScrollHandler, { passive: true });
    }
    this.syncStickyHeaderViewportFromGrid();
  }

  private syncStickyHeaderViewportFromGrid() {
    if (!this.stickyHeaderViewportElement && !this.stickyBottomScrollViewportElement) {
      this.refreshStickyHeaderDomRefs();
    }

    const scrollLeft = this.stickyHeaderHorizontalAlignmentElement?.scrollLeft ?? this.stickyHeaderHorizontalScrollElement?.scrollLeft ?? 0;

    this.stickyHeaderViewportSyncing = true;
    if (this.stickyHeaderViewportElement) {
      this.stickyHeaderViewportElement.scrollLeft = scrollLeft;
    }
    if (this.stickyBottomScrollViewportElement) {
      this.stickyBottomScrollViewportElement.scrollLeft = scrollLeft;
    }
    this.stickyHeaderViewportSyncing = false;
  }

  private updateStickyBottomScrollHelperMetrics() {
    const helperAnchorRect = this.positionsTableBodyElement?.getBoundingClientRect();

    this.stickyBottomScrollHelperViewportWidth = helperAnchorRect ? Math.max(Math.round(helperAnchorRect.width), 0) : 0;
  }

  private isElementVisibleWithinScrollViewport(element: HTMLElement | null, viewportTop: number, viewportBottom: number): boolean {
    if (!element) {
      return false;
    }

    const rect = element.getBoundingClientRect();
    if (rect.height <= 0 || rect.width <= 0) {
      return false;
    }

    return rect.bottom > viewportTop && rect.top < viewportBottom;
  }

  private bindStickyHeaderResizeObserver() {
    if (this.stickyHeaderResizeObserver) {
      this.stickyHeaderResizeObserver.disconnect();
    }

    this.refreshStickyHeaderDomRefs();
    const headerRoot = this.masterGridHeaderElement;

    if (!headerRoot || typeof ResizeObserver === 'undefined') {
      return;
    }

    this.stickyHeaderResizeObserver = new ResizeObserver(() => {
      requestAnimationFrame(() => {
        this.refreshStickyHeaderDomRefs();
        this.updateStickyHeaderTopOffset();
        this.updateStickyHeaderContextUnderHeader();
        this.updateStickyHeaderColumns();
      });
    });

    this.stickyHeaderResizeObserver.observe(headerRoot);
  }

  private updateStickyHeaderTopOffset() {
    const stickyAccountHeader = (document.querySelector('mm-account-info') as HTMLElement | null)
      ?? document.getElementById('account-info-container');
    const headerHeight = stickyAccountHeader?.getBoundingClientRect().height ?? 0;

    this.stickyHeaderTopOffset = headerHeight > 0 ? Math.ceil(headerHeight) : 0;
  }

  // Detect whether the sticky header is sitting over a detail grid so the cloned labels can switch to lot-level context.
  private updateStickyHeaderContextUnderHeader() {
    if (!this.stickyHeaderRowElement) {
      this.refreshStickyHeaderDomRefs();
    }

    const stickyHeaderRow = this.stickyHeaderRowElement;
    const stickyHeaderViewport = this.stickyHeaderViewportElement;

    if (!stickyHeaderRow || !this.stickyHeaderVisible) {
      if (this.detailGridTopContextActive || this.detailGridTopContextSymbol) {
        this.detailGridTopContextActive = false;
        this.detailGridTopContextSymbol = '';
        this.updateStickyHeaderColumns();
      }
      return;
    }

    const sampleRect = stickyHeaderViewport?.getBoundingClientRect() ?? stickyHeaderRow.getBoundingClientRect();
    const sampleX = sampleRect.left + Math.min(220, Math.max(sampleRect.width * 0.2, 40));
    const sampleY = sampleRect.bottom + 4;
    const elementBelowHeader = document.elementFromPoint(sampleX, sampleY) as HTMLElement | null;
    const detailContextElement = elementBelowHeader?.closest('.ag-details-row, .ag-row-detail, .ag-details-grid, .ag-detail-grid, .ag-full-width-row') as HTMLElement | null;
    const isDetailContext = !!detailContextElement;
    const detailContextSymbol = isDetailContext ? this.getStickyHeaderDetailContextSymbol(detailContextElement, sampleY) : '';

    if (this.detailGridTopContextActive !== isDetailContext || this.detailGridTopContextSymbol !== detailContextSymbol) {
      this.detailGridTopContextActive = isDetailContext;
      this.detailGridTopContextSymbol = detailContextSymbol;
      this.updateStickyHeaderColumns();
    }
  }

  // Resolve the active detail symbol from whichever master row currently owns the detail area under the sticky header.
  private getStickyHeaderDetailContextSymbol(detailContextElement: HTMLElement | null, sampleY: number): string {
    if (!detailContextElement) {
      return '';
    }

    const viewportRect = this.masterGridCenterViewportElement?.getBoundingClientRect();
    const viewportScrollTop = this.masterGridCenterViewportElement?.scrollTop ?? 0;

    if (viewportRect) {
      const sampleGridY = sampleY - viewportRect.top + viewportScrollTop;
      const displayedRowCount = this.gridApi?.getDisplayedRowCount?.() ?? 0;

      for (let rowIndex = 0; rowIndex < displayedRowCount; rowIndex++) {
        const rowNode: any = this.gridApi?.getDisplayedRowAtIndex(rowIndex);
        const rowTop = rowNode?.rowTop;
        const rowHeight = rowNode?.rowHeight;

        if (typeof rowTop !== 'number' || typeof rowHeight !== 'number') {
          continue;
        }

        const rowBottom = rowTop + rowHeight;
        if (sampleGridY < rowTop || sampleGridY > rowBottom) {
          continue;
        }

        for (let lookupIndex = rowIndex; lookupIndex >= 0; lookupIndex--) {
          const lookupNode: any = this.gridApi?.getDisplayedRowAtIndex(lookupIndex);
          const symbolFromRow = lookupNode?.data?.[this.colNames.positionSymbol]?.toString().trim() ?? '';

          if (symbolFromRow) {
            return symbolFromRow;
          }
        }

        break;
      }
    }

    const detailRow = detailContextElement.closest('.ag-details-row, .ag-row-detail, .ag-full-width-row, .ag-row') as HTMLElement | null;
    const detailRowIndexValue = detailRow?.getAttribute('row-index')
      || detailRow?.getAttribute('aria-rowindex')
      || '';
    const parsedDetailRowIndex = Number(detailRowIndexValue);
    const detailRowIndex = Number.isFinite(parsedDetailRowIndex)
      ? (detailRow?.hasAttribute('aria-rowindex') ? parsedDetailRowIndex - 1 : parsedDetailRowIndex)
      : NaN;

    if (!Number.isNaN(detailRowIndex) && detailRowIndex >= 0) {
      for (let rowIndex = detailRowIndex; rowIndex >= 0; rowIndex--) {
        const rowNode = this.gridApi?.getDisplayedRowAtIndex(rowIndex);
        const symbolFromRow = rowNode?.data?.[this.colNames.positionSymbol]?.toString().trim() ?? '';

        if (symbolFromRow) {
          return symbolFromRow;
        }
      }
    }

    const detailRowId = detailRow?.getAttribute('row-id')
      || detailRow?.getAttribute('data-row-id')
      || '';
    const masterRowId = detailRowId.startsWith('detail_') ? detailRowId.replace(/^detail_/, '') : detailRowId;
    const masterNode = masterRowId ? this.gridApi?.getRowNode(masterRowId) : undefined;
    const masterSymbol = masterNode?.data?.[this.colNames.positionSymbol]?.toString().trim() ?? '';

    if (masterSymbol) {
      return masterSymbol;
    }

    let sibling: Element | null = detailRow?.previousElementSibling ?? null;

    while (sibling) {
      const row = sibling as HTMLElement;
      const isDetailRow = row.matches('.ag-details-row, .ag-row-detail, .ag-details-grid, .ag-detail-grid, .ag-full-width-row');

      if (!isDetailRow && row.matches('.ag-row')) {
        const symbolCell = row.querySelector('[col-id="Symbol"], [col-id="positonSymbol"], [col-id="positionSymbol"]') as HTMLElement | null;
        const symbolValue = symbolCell?.querySelector('.ag-group-value, .ag-cell-value')?.textContent?.trim()
          || symbolCell?.textContent?.trim()
          || '';

        return symbolValue.replace(/\s+/g, ' ');
      }

      sibling = sibling.previousElementSibling;
    }

    return '';
  }

  // Show the sticky helpers only when they add value: the header is off screen, the grid is still visible, and horizontal overflow exists.
  private updateStickyHeaderVisibility() {
    if (!this.masterGridHeaderElement || !this.masterGridElement) {
      this.refreshStickyHeaderDomRefs();
    }

    if (!this.stickyHeaderColumns.length) {
      this.stickyHeaderVisible = false;
      this.stickyBottomScrollHelperVisible = false;
      this.updateStickyBottomScrollHelperMetrics();
      this.updateStickyHeaderContextUnderHeader();
      return;
    }

    const scrollContainer = this.stickyHeaderScrollContainer ?? document.getElementById('mm-content');
    const gridHeader = this.masterGridHeaderElement;
    const masterGrid = this.masterGridElement;
    const totalsHorizontalScrollbar = this.totalsHorizontalScrollbarElement;

    if (!scrollContainer || !gridHeader || !masterGrid) {
      this.stickyHeaderVisible = false;
      this.stickyBottomScrollHelperVisible = false;
      this.updateStickyBottomScrollHelperMetrics();
      this.updateStickyHeaderContextUnderHeader();
      return;
    }

    const scrollContainerRect = scrollContainer.getBoundingClientRect();
    const containerTop = scrollContainerRect.top;
    const containerBottom = scrollContainerRect.bottom;
    const headerTop = gridHeader.getBoundingClientRect().top;
    const masterGridRect = masterGrid.getBoundingClientRect();
    const masterGridBottom = masterGridRect.bottom;
    const horizontalViewportWidth = this.stickyHeaderHorizontalAlignmentElement?.clientWidth
      ?? this.stickyHeaderHorizontalScrollElement?.clientWidth
      ?? 0;
    const hasHorizontalOverflow = this.stickyHeaderTotalWidth > horizontalViewportWidth + 1;

    this.updateStickyBottomScrollHelperMetrics();

    this.stickyHeaderVisible = headerTop <= containerTop && masterGridBottom > containerTop + 32;
    this.stickyBottomScrollHelperVisible = hasHorizontalOverflow
      && masterGridRect.bottom > containerTop
      && masterGridRect.top < containerBottom
      && !this.isElementVisibleWithinScrollViewport(totalsHorizontalScrollbar, containerTop, containerBottom)
      && this.stickyBottomScrollHelperViewportWidth > 0;
    this.syncStickyHeaderViewportFromGrid();
    this.updateStickyHeaderContextUnderHeader();
  }

  // Push the master-table column widths into every open detail grid only when something actually changed.
  private syncOpenDetailGridColumnWidths() {
    const detailColumnState = (this.detailCellRendererParams.detailGridOptions.columnDefs ?? [])
      .map((columnDef: ColDef) => {
        const colId = columnDef.colId ?? columnDef.field;
        if (!colId || typeof columnDef.width !== 'number') {
          return undefined;
        }

        return {
          colId,
          width: columnDef.width,
          hide: !!columnDef.hide,
        };
      })
      .filter((columnState: { colId: string; width: number; hide: boolean } | undefined): columnState is { colId: string; width: number; hide: boolean } => !!columnState);

    if (!detailColumnState.length) {
      return;
    }

    this.gridApi?.forEachDetailGridInfo(detailGrid => {
      const detailGridApi = detailGrid.api;
      if (!detailGridApi) {
        return;
      }

      const currentColumnState = detailGridApi.getColumnState();
      const hasChanges = detailColumnState.some((columnState: { colId: string; width: number; hide: boolean }, index: number) => {
        const currentState = currentColumnState[index];

        return currentState?.colId !== columnState.colId
          || currentState?.width !== columnState.width
          || !!currentState?.hide !== columnState.hide;
      }) || currentColumnState.length !== detailColumnState.length;

      if (!hasChanges) {
        return;
      }

      detailGridApi.applyColumnState({
        state: detailColumnState,
        applyOrder: true,
      });
      detailGridApi.refreshHeader();
      detailGridApi.redrawRows();
    });
  }

  calculateEMV(toAccountInfo: ToAccountInfoById) {
    this.gridApi?.forEachNode(node => {
      for (const key in toAccountInfo) {
        if (!Number.isNaN(Number(node.data["Shares to move " + key]))) {
          node.setDataValue(('Estimated market value ' + key), this.currencyPipe.transform(Number(node.data["Shares to move " + key]) * Number(node.data["Current price/share"].replace('$', '').replaceAll(',', '')) * Math.sign(Number(node.data["currentAvailableShares"])) * Number(node.data["valMultiplier"])));
        }
      }
    });
  }


  ngOnChanges(): void {
    if (this.gridApi) {
      setTimeout(() => {
        this.updateValues();
      });
    }
    if (this.maxLotsWarning.displayWarning) {
      this.scrollToHtmlId('errorBanners');
    }
  }

  onFilterChanged(params: FilterChangedEvent) {
    this.updateValues();
  }

  updateValues() {
    if (this.gridApi) {
      this.displayedRows = this.gridApi.getDisplayedRowCount();
      this.numberOfFilters = this.setNumberOfFilters();
    }
  }

  private setDisplayedRows(): number {
    var displayedRows = 0;
    this.gridApi?.forEachNodeAfterFilter(() => displayedRows++);
    return displayedRows;
  }

  private setNumberOfFilters(): number {
    if (this.gridApi) {
      const filterModel = this.gridApi.getFilterModel();
      return Object.keys(filterModel).length;
    }
    return 0;
  }

  clearFilters(event: any) {
    event.preventDefault();
    this.gridApi?.setFilterModel(null);
  }

  expandOrCollapse() {
    this.expanded = !this.expanded;
    this.expandOrCollapseRows(this.expanded, true);
  }

  public initializeRowDataStore(toAccountInfo: ToAccountInfoById): RowDataById {
    let rowData: RowDataById = {};
    let byId: RowDataById = {};
    let positions: PositionDetailsForMultiToAccount[] = [];
    this.store.select(selectMultipleToAccountsPositionLotTableData).pipe(take(1)).subscribe((data) => {
      rowData = data;
    });
    this.store.select(selectPositionDetails).pipe(take(1)).subscribe(details => {
      positions = details?.positions;
    });

    if (Object.keys(toAccountInfo).length > 0) {
      Object.keys(toAccountInfo).forEach((toAccountId) => {
        if (positions.length === 0) {
          byId = {};
        } else if (Object.keys(rowData).includes(toAccountId)) {
          byId = { ...byId, ...rowData };
        } else {
          let tableColumn: PositionsLotsTableColumnMultipleAccounts[] = positions.map(position => {
            return {
              Symbol: position.symbol,
              Name: this.convertToCamelCase(position.symbolName),
              RowHeight: positionConstants.tableRowHeight,
              'Available shares': `${this.decimalPipe.transform(position.totalQuantity, '1.0-5')} (${position.numberOfLots} ${position.numberOfLots === 1 ? 'lot' : 'lots'})`,
              'Current price/share': position.currentPricePerShare,
              'Cost basis': position.costBasis,
              'Shares to move': this.totalDistSelected ? Number(this.decimalPipe?.transform(position.totalQuantity, '1.0-5')?.replaceAll(',', '')?.replace('-', '')) : '',
              'Estimated market value': '',
              'lotDetail': position.lots,
              'setToAverage': position.setToAverage,
              'restrictions': position.toAccountPositionDetails[toAccountId]?.restriction,
              'Quantity': position.quantity,
              'cmtSequenceId': position.cmtSequenceId,
              'valMultiplier': position.valMultiplier,
              'schwabSecurityId': position.schwabSecurityId,
            };
          });
          let data: RowDataById = {
            [toAccountId]: {
              positionData: tableColumn,
              sharesToMoveTotal: 0,
              estimatedMarketValueTotal: 0,
              nodeCostBasis: this.costBasisMethod ?? ''
            }
          };
          byId = { ...rowData, ...data };
        }
      });
    } else {
      byId = {};
    }

    return byId;
  }

  getRowHeight = (
    params: RowHeightParams
  ) => this.getHeight(params);

  ngOnDestroy(): void {
    if (this.scrollToTopAfterLayoutTimeout) {
      clearTimeout(this.scrollToTopAfterLayoutTimeout);
    }
    this.reviewReturnRecoveryTimeouts.forEach(timeoutId => clearTimeout(timeoutId));
    this.reviewReturnRecoveryTimeouts = [];
    this.scheduledLayoutPassTimeouts.forEach(timeoutId => clearTimeout(timeoutId));
    this.scheduledLayoutPassTimeouts = [];
    if (this.scheduledGridWidthSyncTimeout) {
      clearTimeout(this.scheduledGridWidthSyncTimeout);
      this.scheduledGridWidthSyncTimeout = undefined;
    }
    if (this.positionsTableTopScrollAnimationFrame !== undefined) {
      cancelAnimationFrame(this.positionsTableTopScrollAnimationFrame);
      this.positionsTableTopScrollAnimationFrame = undefined;
    }
    if (this.stickyHeaderRefreshAnimationFrame !== undefined) {
      cancelAnimationFrame(this.stickyHeaderRefreshAnimationFrame);
      this.stickyHeaderRefreshAnimationFrame = undefined;
    }
    if (this.stickyHeaderScrollContainer) {
      this.removeStickyHeaderListener(this.stickyHeaderScrollContainer, this.stickyHeaderScrollHandler);
      this.stickyHeaderScrollContainer = null;
    }
    if (this.stickyHeaderHorizontalScrollElement) {
      this.removeStickyHeaderListener(this.stickyHeaderHorizontalScrollElement, this.stickyHeaderHorizontalScrollHandler);
      this.stickyHeaderHorizontalScrollElement = null;
    }
    if (this.stickyHeaderHorizontalAlignmentElement) {
      this.removeStickyHeaderListener(this.stickyHeaderHorizontalAlignmentElement, this.stickyHeaderHorizontalScrollHandler);
      this.stickyHeaderHorizontalAlignmentElement = null;
    }
    if (this.stickyHeaderResizeObserver) {
      this.stickyHeaderResizeObserver.disconnect();
      this.stickyHeaderResizeObserver = undefined;
    }
    this.stickyHeaderViewportElement = null;
    this.stickyHeaderRowElement = null;
    this.stickyBottomScrollViewportElement = null;
    this.positionsTableBodyElement = null;
    this.masterGridHeaderElement = null;
    this.masterGridElement = null;
    this.masterGridCenterViewportElement = null;
    this.masterGridHeaderViewportElement = null;
    this.masterGridHeaderContainerElement = null;
    this.masterGridCenterContainerElement = null;
    this.masterGridLeafHeaderRowElement = null;
    this.totalsHorizontalScrollbarElement = null;
    this.totalsHorizontalScrollViewportElement = null;
    this.destroy$.next(true);
    this.destroy$.complete();
    if (this.isEdit) {
      this.store.dispatch(TransactionFormActions.editLoadComplete());
    }
  }

  getHeight(params: any) {
    let keys = Object.keys(params?.data?.restrictionsInfo ?? []);
    for (let i = 0; i < keys.length; i++) {
      if ((params?.data?.restrictionsInfo[keys[i]]?.restriction?.restrictionText == positionConstants.positionMismatchRestriction || params?.data?.restrictionsInfo[keys[i]]?.restriction?.restrictionText.startsWith('DUPLICATE')) && this.costBasisMethod == 'None') {
        return positionConstants.tableRestrictedMessageRowHeight;
      }
    }
    return positionConstants.tableRowHeight;
  }

  isDuplicateRestrictionText(restrictionText?: string): boolean {
    return !!restrictionText && restrictionText.startsWith('DUPLICATE');
  }

  isMF30DaySpecificDuplicateRestrictionText(restrictionText?: string): boolean {
    return restrictionText === 'DUPLICATE: Contact service tm to review procedure for MF 30 day Margin.';
  }

  hasDuplicateRestrictionInRow(rowData: any): boolean {
    return Object.values(rowData?.restrictionsInfo ?? {}).some(
      (restrictionInfo: any) => this.isDuplicateRestrictionText(restrictionInfo?.restriction?.restrictionText)
    );
  }

  updateGridReady(ready: boolean) {
    this.store.dispatch(gridReady({ gridReady: ready }));
  }

  convertToCamelCase(symbolName: string) {
    return symbolName.split(' ').map(function (word, index) {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }).join(' ');
  }

  currencyComparator(valueA: string | number, valueB: string | number) {
    if (typeof valueA === 'string' && typeof valueB === 'string') {
      valueA = +valueA.replace(/[^\-\w\s^.]/gi, '');
      valueB = +(valueB.replace(/[^\-\w\s^.]/gi, ''));
    }
    return +valueA - +valueB;
  }

  managePositionLotTableState() {
    var toAccountInfoById: ToAccountInfoById;
    combineLatest([
      this.store.select(selectPositionsLotsTableState),
      this.store.select(selectToAccountsInfo),
      this.store.select(isRestrictedToAccountEntered)
    ]).pipe(takeUntil(this.destroy$), switchMap(([positionTableState, toAccountInfo, isRestrictedAccount]) => {
      toAccountInfoById = toAccountInfo;
      this.isRestrictedAccount = isRestrictedAccount;
      if ((Object.keys(toAccountInfo).length === 0 && !positionTableState.loading) || isRestrictedAccount) {
        this.displayTable$.next(false);
        this.tableMessage = positionConstants.ToAccountNotEnteredMessage;
        this.showSetToAverageMessageCounter = 0;
        this.shares = 0;
        this.emvFormatted = this.currencyPipe.transform(0);
        this.lotDetail = [];
        this.hasAnyQuantityMismatchPositions = false;
        this.hasDuplicateRestriction = false;
        this.hasDuplicateRestrictionMF30DaySpecific = false;
        return this.store.select(selectPositionLotDetails).pipe(takeUntil(this.destroy$), map(info => info.positions));
      } else if (positionTableState.hasError) {
        this.displayTable$.next(false);
        this.tableMessage = positionConstants.PositionLotErrorResponseMessage;
      } else if (this.positions === 0 || isRestrictedAccount) {
        this.displayTable$.next(false);
        if (isRestrictedAccount) {
          this.tableMessage = positionConstants.ToAccountNotEnteredMessage;
        } else {
          this.tableMessage = positionConstants.AccountHasNoPositionsMessage;
        }
      } else {
        this.displayTable$.next(true);
        this.store.dispatch(InternalTransfersActions.itUpdateRowData(this.initializeRowDataStore(toAccountInfo)));
      }
      return of([]);
    })).subscribe(result => {
      if (result.length) {
        this.store.dispatch(InternalTransfersActions.itUpdateRowData(this.initializeRowDataStore(toAccountInfoById)));
      }
    });
  }

  constructor(private store: Store, private currencyPipe: CurrencyPipe, private decimalPipe: DecimalPipe, private reviewInputPositionObserbableService: ReviewInputPositionObservableService, private actions$: Actions) {
    this.excelStyles = [
      {
        id: "cell",
        font: { color: 'black', },
        alignment: { vertical: 'Center', horizontal: 'Center', wrapText: true },
        borders:
        {
          borderBottom: { color: '#000000', lineStyle: 'Continuous', weight: 1, },
          borderLeft: { color: '#000000', lineStyle: 'Continuous', weight: 1, },
          borderRight: { color: '#000000', lineStyle: 'Continuous', weight: 1, },
          borderTop: { color: '#000000', lineStyle: 'Continuous', weight: 1, }
        }
      },
      {
        id: "body",
        font: { color: 'black', },
        alignment: { vertical: 'Center', horizontal: 'Center' },
        borders:
        {
          borderBottom: { color: '#000000', lineStyle: 'Continuous', weight: 1, },
          borderLeft: { color: '#000000', lineStyle: 'Continuous', weight: 1, },
          borderRight: { color: '#000000', lineStyle: 'Continuous', weight: 1, },
          borderTop: { color: '#000000', lineStyle: 'Continuous', weight: 1, }
        }
      },
      {
        id: 'header',
        font: { bold: true },
        interior: { color: '#F1F1F1', pattern: 'Solid', patternColor: 'white' },
        alignment: { vertical: 'Center', horizontal: 'Center', },
        borders:
        {
          borderBottom: { color: '#000000', lineStyle: 'Continuous', weight: 1, },
          borderLeft: { color: '#000000', lineStyle: 'Continuous', weight: 1, },
          borderRight: { color: '#000000', lineStyle: 'Continuous', weight: 1, },
          borderTop: { color: '#000000', lineStyle: 'Continuous', weight: 1, }
        }
      }];
  }
}

function cell(text: string, styleId?: string): ExcelCell {
  return {
    styleId: styleId,
    data: {
      type: /^\d+$/.test(text) ? "Number" : "String",
      value: String(text),
    },
  };
}